{
  "library": {
    "ImageMetaPanel": {
      "id": "ImageMetaPanel",
      "name": "ImageMetaPanel",
      "tag": "div",
      "type": "frame",
      "emits": ["close"],
      "css": ".btn-pill[__sc__]{cursor:pointer;background:transparent;font-family:Inter;font-size:12px;font-weight:600;color:rgb(180,182,190);border:1px solid rgb(69,69,69);border-radius:8px;text-decoration:none;transition:transform 0.08s,filter 0.15s,border-color 0.15s,background 0.15s}\n.btn-pill[__sc__]:hover{background:rgba(255,255,255,0.06)}\n.btn-pill--push[__sc__]{margin-left:auto}\n.meta-title[__sc__]{font-family:Inter;font-size:13px;line-height:18px;font-weight:500;color:rgb(249,249,249)}\n.meta-card[__sc__]{background:rgb(50,50,50);border:1px solid rgb(69,69,69);border-radius:10px}\n.meta-label[__sc__]{font-family:Inter;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.6px;color:rgb(135,138,146)}\n.meta-value[__sc__]{font-family:Inter;font-size:13px;line-height:19px;color:rgb(249,249,249)}\n.meta-value--muted[__sc__]{color:rgb(180,182,190)}\n.meta-divider[__sc__]{background:rgb(69,69,69)}\n.meta-grid[__sc__]{display:grid;grid-template-columns:repeat(2,1fr)}\n.cell-label[__sc__]{font-family:Inter;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.4px;color:rgb(135,138,146)}\n.cell-value[__sc__]{font-family:Inter;font-size:13px;font-weight:500;color:rgb(249,249,249);text-overflow:ellipsis;white-space:nowrap}",
      "props": {
        "prompt": {
          "type": "string",
          "default": ""
        },
        "negative": {
          "type": "string",
          "default": ""
        },
        "model": {
          "type": "string",
          "default": ""
        },
        "style": {
          "type": "string",
          "default": ""
        },
        "aspect": {
          "type": "string",
          "default": ""
        },
        "cfgScale": {
          "type": "number",
          "default": 0
        },
        "steps": {
          "type": "number",
          "default": 0
        },
        "seed": {
          "type": "number",
          "default": 0
        },
        "sampler": {
          "type": "string",
          "default": ""
        },
        "scheduler": {
          "type": "string",
          "default": ""
        }
      },
      "layout": {
        "gap": {
          "mode": "px",
          "value": 10
        },
        "direction": "column"
      },
      "children": [
        {
          "id": "meta-toolbar",
          "tag": "div",
          "type": "frame",
          "layout": {
            "gap": {
              "mode": "px",
              "value": 10
            },
            "align": "center"
          },
          "children": [
            {
              "id": "meta-title-wrap",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 6
                },
                "align": "center",
                "height": {
                  "mode": "px",
                  "value": 18
                }
              },
              "children": [
                {
                  "id": "meta-title",
                  "tag": "span",
                  "text": "Metadata",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["meta-title"],
                  "layoutMode": "auto"
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "btn-use-as-base-side",
              "tag": "button",
              "type": "frame",
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 6
                },
                "align": "center",
                "width": {
                  "mode": "auto"
                },
                "height": {
                  "mode": "px",
                  "value": 30
                },
                "justify": "center",
                "padding": [
                  {
                    "mode": "px",
                    "value": 0
                  },
                  {
                    "mode": "px",
                    "value": 10
                  }
                ]
              },
              "children": [
                {
                  "id": "icon-use-as-base-side",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "14",
                    "height": "14",
                    "viewBox": "0 0 16 16"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "icon-use-as-base-side-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M4 8h8m-3-3l3 3-3 3",
                        "stroke": "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "auto"
                },
                {
                  "id": "btn-use-as-base-side-label",
                  "text": "Use as base",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "layoutMode": "auto",
                  "tag": "div"
                }
              ],
              "triggers": [
                {
                  "on": "click",
                  "action": "emit",
                  "target": "useAsBase",
                  "payload": {
                    "prompt": "{{props.prompt}}",
                    "negative": "{{props.negative}}",
                    "model": "{{props.model}}",
                    "seed": "{{props.seed}}",
                    "cfgScale": "{{props.cfgScale}}",
                    "steps": "{{props.steps}}",
                    "sampler": "{{props.sampler}}",
                    "scheduler": "{{props.scheduler}}",
                    "aspect": "{{props.aspect}}"
                  }
                }
              ],
              "cssClasses": ["btn-pill", "btn-pill--push"],
              "layoutMode": "flow"
            },
            {
              "id": "btn-copy-params",
              "tag": "button",
              "type": "frame",
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 6
                },
                "align": "center",
                "width": {
                  "mode": "auto"
                },
                "height": {
                  "mode": "px",
                  "value": 30
                },
                "justify": "center",
                "padding": [
                  {
                    "mode": "px",
                    "value": 0
                  },
                  {
                    "mode": "px",
                    "value": 10
                  }
                ]
              },
              "children": [
                {
                  "id": "icon-copy",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "14",
                    "height": "14",
                    "viewBox": "0 0 16 16"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "icon-copy-rect",
                      "tag": "rect",
                      "type": "frame",
                      "attrs": {
                        "x": "5",
                        "y": "5",
                        "rx": "1.5",
                        "width": "9",
                        "height": "9",
                        "stroke": "currentColor",
                        "stroke-width": "1.4"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "auto"
                    },
                    {
                      "id": "icon-copy-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M11 5V3.5A1.5 1.5 0 009.5 2h-6A1.5 1.5 0 002 3.5v6A1.5 1.5 0 003.5 11H5",
                        "stroke": "currentColor",
                        "stroke-width": "1.4"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "auto"
                },
                {
                  "id": "btn-copy-params-label",
                  "text": "Copy parameters",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "layoutMode": "auto",
                  "tag": "div"
                }
              ],
              "triggers": [
                {
                  "on": "click",
                  "chain": [
                    {
                      "action": "set",
                      "target": "$seed",
                      "value": "{{props.seed}}"
                    },
                    {
                      "action": "set",
                      "target": "$seedMode",
                      "value": "manual"
                    },
                    {
                      "action": "set",
                      "target": "$cfgScale",
                      "value": "{{props.cfgScale}}"
                    },
                    {
                      "action": "set",
                      "target": "$steps",
                      "value": "{{props.steps}}"
                    },
                    {
                      "action": "set",
                      "target": "$sampler",
                      "value": "{{props.sampler}}"
                    },
                    {
                      "action": "set",
                      "target": "$scheduler",
                      "value": "{{props.scheduler}}"
                    },
                    {
                      "action": "set",
                      "target": "$_imgDetailsOpen",
                      "value": false
                    },
                    {
                      "action": "emit",
                      "target": "close"
                    }
                  ]
                }
              ],
              "cssClasses": ["btn-pill"],
              "layoutMode": "flow"
            }
          ],
          "layoutMode": "flow"
        },
        {
          "id": "meta-card",
          "tag": "div",
          "type": "frame",
          "layout": {
            "gap": {
              "mode": "px",
              "value": 12
            },
            "padding": {
              "mode": "px",
              "value": 14
            },
            "direction": "column"
          },
          "children": [
            {
              "id": "field-prompt",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 4
                },
                "direction": "column"
              },
              "children": [
                {
                  "id": "field-prompt-label",
                  "tag": "span",
                  "text": "Prompt",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["meta-label"],
                  "layoutMode": "auto"
                },
                {
                  "id": "field-prompt-value",
                  "tag": "span",
                  "text": "{{props.prompt || '—'}}",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["meta-value"],
                  "layoutMode": "auto"
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "field-negative",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 4
                },
                "direction": "column"
              },
              "children": [
                {
                  "id": "field-negative-label",
                  "tag": "span",
                  "text": "Negative",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["meta-label"],
                  "layoutMode": "auto"
                },
                {
                  "id": "field-negative-value",
                  "tag": "span",
                  "text": "{{props.negative || '—'}}",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["meta-value", "meta-value--muted"],
                  "layoutMode": "auto"
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "meta-divider",
              "tag": "div",
              "type": "frame",
              "layout": {
                "height": {
                  "mode": "px",
                  "value": 1
                }
              },
              "children": [],
              "cssClasses": ["meta-divider"],
              "layoutMode": "auto"
            },
            {
              "id": "meta-grid",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 14
                }
              },
              "children": [
                {
                  "id": "cell-model",
                  "tag": "div",
                  "type": "frame",
                  "layout": {
                    "gap": {
                      "mode": "px",
                      "value": 3
                    },
                    "direction": "column"
                  },
                  "children": [
                    {
                      "id": "cell-model-label",
                      "tag": "span",
                      "text": "Model",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "cssClasses": ["cell-label"],
                      "layoutMode": "auto"
                    },
                    {
                      "id": "cell-model-value",
                      "tag": "span",
                      "text": "{{props.model || '—'}}",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "cssClasses": ["cell-value"],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "flow"
                },
                {
                  "id": "cell-style",
                  "tag": "div",
                  "type": "frame",
                  "layout": {
                    "gap": {
                      "mode": "px",
                      "value": 3
                    },
                    "direction": "column"
                  },
                  "children": [
                    {
                      "id": "cell-style-label",
                      "tag": "span",
                      "text": "Style",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "cssClasses": ["cell-label"],
                      "layoutMode": "auto"
                    },
                    {
                      "id": "cell-style-value",
                      "tag": "span",
                      "text": "{{props.style || '—'}}",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "cssClasses": ["cell-value"],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "flow"
                },
                {
                  "id": "cell-aspect",
                  "tag": "div",
                  "type": "frame",
                  "layout": {
                    "gap": {
                      "mode": "px",
                      "value": 3
                    },
                    "direction": "column"
                  },
                  "children": [
                    {
                      "id": "cell-aspect-label",
                      "tag": "span",
                      "text": "Resolution",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "cssClasses": ["cell-label"],
                      "layoutMode": "auto"
                    },
                    {
                      "id": "cell-aspect-value",
                      "tag": "span",
                      "text": "{{props.aspect || '—'}}",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "cssClasses": ["cell-value"],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "flow"
                },
                {
                  "id": "cell-cfg",
                  "tag": "div",
                  "type": "frame",
                  "layout": {
                    "gap": {
                      "mode": "px",
                      "value": 3
                    },
                    "direction": "column"
                  },
                  "children": [
                    {
                      "id": "cell-cfg-label",
                      "tag": "span",
                      "text": "CFG scale",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "cssClasses": ["cell-label"],
                      "layoutMode": "auto"
                    },
                    {
                      "id": "cell-cfg-value",
                      "tag": "span",
                      "text": "{{props.cfgScale || '—'}}",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "cssClasses": ["cell-value"],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "flow"
                },
                {
                  "id": "cell-steps",
                  "tag": "div",
                  "type": "frame",
                  "layout": {
                    "gap": {
                      "mode": "px",
                      "value": 3
                    },
                    "direction": "column"
                  },
                  "children": [
                    {
                      "id": "cell-steps-label",
                      "tag": "span",
                      "text": "Steps",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "cssClasses": ["cell-label"],
                      "layoutMode": "auto"
                    },
                    {
                      "id": "cell-steps-value",
                      "tag": "span",
                      "text": "{{props.steps || '—'}}",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "cssClasses": ["cell-value"],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "flow"
                },
                {
                  "id": "cell-seed",
                  "tag": "div",
                  "type": "frame",
                  "layout": {
                    "gap": {
                      "mode": "px",
                      "value": 3
                    },
                    "direction": "column"
                  },
                  "children": [
                    {
                      "id": "cell-seed-label",
                      "tag": "span",
                      "text": "Seed",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "cssClasses": ["cell-label"],
                      "layoutMode": "auto"
                    },
                    {
                      "id": "cell-seed-value",
                      "tag": "span",
                      "text": "{{props.seed || '—'}}",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "cssClasses": ["cell-value"],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "flow"
                }
              ],
              "cssClasses": ["meta-grid"],
              "layoutMode": "auto"
            }
          ],
          "cssClasses": ["meta-card"],
          "layoutMode": "flow"
        }
      ],
      "layoutMode": "flow"
    },
    "ImageMetaSheet": {
      "id": "ImageMetaSheet",
      "name": "ImageMetaSheet",
      "tag": "div",
      "type": "frame",
      "emits": ["close"],
      "props": {
        "prompt": {
          "type": "string",
          "default": ""
        },
        "negative": {
          "type": "string",
          "default": ""
        },
        "model": {
          "type": "string",
          "default": ""
        },
        "style": {
          "type": "string",
          "default": ""
        },
        "aspect": {
          "type": "string",
          "default": ""
        },
        "cfgScale": {
          "type": "number",
          "default": 0
        },
        "steps": {
          "type": "number",
          "default": 0
        },
        "seed": {
          "type": "number",
          "default": 0
        },
        "sampler": {
          "type": "string",
          "default": ""
        },
        "scheduler": {
          "type": "string",
          "default": ""
        }
      },
      "style": {
        "raw": {
          "max-height": "80vh",
          "overflow-y": "auto",
          "background": "rgb(43,43,43)",
          "border-top-left-radius": "18px",
          "border-top-right-radius": "18px",
          "animation": "sheet-slide-up 0.25s cubic-bezier(0.2,0,0,1) both"
        }
      },
      "layout": {
        "gap": {
          "mode": "px",
          "value": 0
        },
        "direction": "column",
        "position": "relative",
        "width": {
          "mode": "percent",
          "value": 100
        },
        "paddingRem": [0.75, 1, 1.75, 1]
      },
      "children": [
        {
          "id": "sheet-drag-handle",
          "tag": "div",
          "type": "frame",
          "style": {
            "raw": {
              "border-radius": "999px",
              "background": "rgb(69,69,69)",
              "margin": "0 auto 12px"
            }
          },
          "layout": {
            "width": {
              "mode": "px",
              "value": 36
            },
            "height": {
              "mode": "px",
              "value": 4
            }
          },
          "children": [],
          "layoutMode": "flow"
        },
        {
          "id": "sheet-meta-panel",
          "ref": "ImageMetaPanel",
          "type": "frame",
          "props": {
            "prompt": "{{props.prompt}}",
            "negative": "{{props.negative}}",
            "model": "{{props.model}}",
            "style": "{{props.style}}",
            "aspect": "{{props.aspect}}",
            "cfgScale": "{{props.cfgScale}}",
            "steps": "{{props.steps}}",
            "seed": "{{props.seed}}",
            "sampler": "{{props.sampler}}",
            "scheduler": "{{props.scheduler}}"
          },
          "on": {
            "close": {
              "action": "emit",
              "target": "close"
            }
          },
          "layout": {},
          "children": [],
          "layoutMode": "flow",
          "tag": "div"
        }
      ],
      "layoutMode": "flow"
    },
    "SavePresetModal": {
      "id": "SavePresetModal",
      "tag": "div",
      "name": "SavePresetModal",
      "type": "frame",
      "emits": ["close"],
      "style": {
        "raw": {
          "background": "#2B2B2B",
          "box-shadow": "0 16px 48px rgba(0,0,0,0.5)",
          "transition": "border-color 0.15s, transform 0.15s"
        },
        "hover": {
          "borderColor": "#454545"
        },
        "radius": {
          "mode": "px",
          "value": 12
        },
        "borderColor": "rgb(47,47,47)",
        "borderStyle": "solid",
        "borderWidthPx": 1
      },
      "layout": {
        "direction": "column",
        "gap": {
          "mode": "px",
          "value": 16
        },
        "padding": {
          "mode": "px",
          "value": 16
        },
        "width": {
          "mode": "rem",
          "value": 18.75
        },
        "minHeight": {
          "mode": "px",
          "value": 0
        }
      },
      "children": [
        {
          "id": "save-preset-modal-header",
          "tag": "div",
          "type": "frame",
          "style": {},
          "layout": {
            "align": "center",
            "justify": "center",
            "width": {
              "mode": "percent",
              "value": 100
            },
            "minHeight": {
              "mode": "px",
              "value": 18
            },
            "position": "relative"
          },
          "children": [
            {
              "id": "save-preset-modal-title",
              "tag": "div",
              "text": "Save preset",
              "type": "frame",
              "style": {
                "raw": {
                  "text-align": "center",
                  "line-height": "2rem"
                },
                "fontSize": {
                  "mode": "rem",
                  "value": 1.5
                },
                "textColor": "#F9F9F9",
                "fontWeight": 500
              },
              "layout": {},
              "children": [],
              "layoutMode": "auto"
            },
            {
              "id": "save-preset-modal-close",
              "tag": "span",
              "text": "×",
              "type": "frame",
              "style": {
                "raw": {
                  "cursor": "pointer",
                  "right": "0",
                  "text-align": "center",
                  "transition": "color 0.15s",
                  "font-family": "system-ui, -apple-system, sans-serif",
                  "line-height": "24px",
                  "user-select": "none"
                },
                "hover": {
                  "textColor": "#F9F9F9"
                },
                "fontSize": {
                  "mode": "px",
                  "value": 24
                },
                "textColor": "#696A6D",
                "fontWeight": 300
              },
              "layout": {
                "align": "center",
                "width": {
                  "mode": "px",
                  "value": 24
                },
                "height": {
                  "mode": "px",
                  "value": 24
                },
                "justify": "center",
                "position": "absolute"
              },
              "children": [],
              "triggers": [
                {
                  "on": "click",
                  "chain": [
                    {
                      "action": "set",
                      "target": "$presetName",
                      "value": ""
                    },
                    {
                      "action": "emit",
                      "target": "close"
                    }
                  ]
                }
              ],
              "layoutMode": "auto"
            }
          ],
          "layoutMode": "flow"
        },
        {
          "id": "save-preset-modal-input",
          "tag": "input",
          "type": "frame",
          "attrs": {
            "type": "text",
            "value": "{{ globals.presetName }}",
            "placeholder": "Enter preset name"
          },
          "state": {
            "_tmp": ""
          },
          "style": {
            "raw": {
              "outline": "none",
              "box-sizing": "border-box",
              "background": "rgb(50,50,50)",
              "transition": "border-color 0.15s, background 0.15s"
            },
            "hover": {
              "backgroundColor": "rgb(56,56,56)"
            },
            "focus": {
              "borderColor": "rgb(226,137,255)",
              "backgroundColor": "rgb(56,56,56)"
            },
            "radius": {
              "mode": "px",
              "value": 8
            },
            "fontSize": {
              "mode": "px",
              "value": 12
            },
            "textColor": "#F9F9F9",
            "fontFamily": "Inter,sans-serif",
            "borderColor": "rgb(56,56,56)",
            "borderStyle": "solid",
            "borderWidthPx": 1
          },
          "layout": {
            "width": {
              "mode": "fill"
            },
            "padding": [
              {
                "mode": "px",
                "value": 8
              },
              {
                "mode": "px",
                "value": 12
              }
            ]
          },
          "children": [],
          "triggers": [
            {
              "on": "input",
              "chain": [
                {
                  "action": "readValue",
                  "target": "#_tmp",
                  "readFrom": "value"
                },
                {
                  "action": "set",
                  "target": "$presetName",
                  "value": "{{ state._tmp }}"
                }
              ]
            }
          ],
          "layoutMode": "auto"
        },
        {
          "id": "save-preset-modal-hint",
          "tag": "span",
          "type": "frame",
          "text": "Max name length: 32",
          "style": {
            "fontSize": {
              "mode": "px",
              "value": 11
            },
            "textColor": "rgb(135,138,146)",
            "fontFamily": "Inter,sans-serif"
          },
          "layout": {},
          "children": [],
          "layoutMode": "auto"
        },
        {
          "id": "save-preset-modal-actions",
          "tag": "div",
          "type": "frame",
          "layout": {
            "gap": {
              "mode": "px",
              "value": 16
            },
            "width": {
              "mode": "percent",
              "value": 100
            },
            "minHeight": {
              "mode": "px",
              "value": 18
            }
          },
          "children": [
            {
              "id": "save-preset-modal-cancel",
              "tag": "button",
              "text": "Cancel",
              "type": "frame",
              "style": {
                "raw": {
                  "cursor": "pointer",
                  "flex": "1 1 0%",
                  "background": "#454545",
                  "transition": "background 0.15s",
                  "white-space": "nowrap",
                  "line-height": "1"
                },
                "hover": {
                  "backgroundColor": "#545456"
                },
                "radius": {
                  "mode": "px",
                  "value": 8
                },
                "fontSize": {
                  "mode": "px",
                  "value": 14
                },
                "textColor": "#F9F9F9",
                "fontFamily": "Inter,sans-serif",
                "fontWeight": 400,
                "borderColor": "transparent",
                "borderStyle": "solid",
                "borderWidthPx": 1
              },
              "layout": {
                "align": "center",
                "justify": "center",
                "height": {
                  "mode": "px",
                  "value": 38
                },
                "padding": [
                  {
                    "mode": "px",
                    "value": 8
                  },
                  {
                    "mode": "px",
                    "value": 16
                  }
                ]
              },
              "children": [],
              "triggers": [
                {
                  "on": "click",
                  "chain": [
                    {
                      "action": "set",
                      "target": "$presetName",
                      "value": ""
                    },
                    {
                      "action": "emit",
                      "target": "close"
                    }
                  ]
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "save-preset-modal-save",
              "tag": "button",
              "text": "Save",
              "type": "frame",
              "style": {
                "raw": {
                  "cursor": "pointer",
                  "flex": "1 1 0%",
                  "background": "linear-gradient(121deg, #7958F2 18.1%, #8026FF 90.98%)",
                  "transition": "background 0.15s, transform 0.15s",
                  "white-space": "nowrap",
                  "line-height": "1"
                },
                "hover": {
                  "raw": {
                    "background": "linear-gradient(121deg, #8666F8 18.1%, #8D3DFE 90.98%)"
                  }
                },
                "active": {
                  "raw": {
                    "background": "linear-gradient(121deg, #6548CC 18.1%, #6548CC 90.98%)"
                  }
                },
                "when": [
                  {
                    "expr": "!globals.presetName || !globals.presetName.trim() || globals.presetName.trim().length > 64",
                    "apply": {
                      "raw": {
                        "opacity": "0.5",
                        "cursor": "not-allowed"
                      }
                    }
                  }
                ],
                "radius": {
                  "mode": "px",
                  "value": 8
                },
                "fontSize": {
                  "mode": "px",
                  "value": 14
                },
                "textColor": "#F9F9F9",
                "fontFamily": "Inter,sans-serif",
                "fontWeight": 400,
                "borderColor": "transparent",
                "borderStyle": "solid",
                "borderWidthPx": 1
              },
              "layout": {
                "align": "center",
                "justify": "center",
                "height": {
                  "mode": "px",
                  "value": 38
                },
                "padding": [
                  {
                    "mode": "px",
                    "value": 8
                  },
                  {
                    "mode": "px",
                    "value": 16
                  }
                ]
              },
              "children": [],
              "triggers": [
                {
                  "on": "click",
                  "condition": "{{ !!globals.presetName && !!globals.presetName.trim() && globals.presetName.trim().length <= 32 }}",
                  "chain": [
                    {
                      "action": "set",
                      "target": "$_savePresetRequested",
                      "value": true
                    },
                    {
                      "action": "emit",
                      "target": "close"
                    }
                  ]
                }
              ],
              "layoutMode": "flow"
            }
          ],
          "layoutMode": "flow"
        }
      ],
      "layoutMode": "flow"
    },
    "IgInput": {
      "id": "Input",
      "tag": "div",
      "type": "frame",
      "emits": ["change"],
      "props": {
        "value": {
          "type": "string"
        },
        "placeholder": {
          "type": "string",
          "default": "Seed"
        }
      },
      "style": {
        "raw": {
          "flex": "1 1 0%"
        }
      },
      "layout": {
        "align": "center",
        "position": "relative"
      },
      "children": [
        {
          "id": "frame-79c6abf0",
          "tag": "input",
          "text": "",
          "type": "frame",
          "attrs": {
            "type": "text",
            "value": "{{props.value}}",
            "placeholder": "{{props.placeholder}}"
          },
          "style": {
            "raw": {
              "outline": "none",
              "background": "rgb(50,50,50)",
              "box-sizing": "border-box",
              "transition": "border-color 0.15s"
            },
            "radius": {
              "mode": "px",
              "value": 8
            },
            "fontSize": {
              "mode": "px",
              "value": 13
            },
            "textColor": "rgb(249,249,249)",
            "fontFamily": "Inter",
            "borderColor": "rgb(69,69,69)",
            "borderStyle": "solid",
            "borderWidthPx": 1
          },
          "layout": {
            "width": {
              "mode": "fill"
            },
            "height": {
              "mode": "px",
              "value": 38
            },
            "padding": [
              {
                "mode": "px",
                "value": 0
              },
              {
                "mode": "px",
                "value": 12
              }
            ]
          },
          "children": [],
          "triggers": [
            {
              "on": "input",
              "chain": [
                {
                  "action": "readValue",
                  "target": "#_tmp",
                  "readFrom": "value"
                },
                {
                  "action": "emit",
                  "target": "change",
                  "payload": "{{state._tmp}}"
                }
              ],
              "action": "readValue",
              "target": "#_tmp",
              "readFrom": "value"
            }
          ],
          "layoutMode": "auto"
        }
      ],
      "layoutMode": "flow"
    },
    "IgToggle": {
      "id": "Toggle",
      "tag": "span",
      "name": "Toggle",
      "type": "frame",
      "emits": ["change"],
      "props": {
        "value": {
          "type": "boolean",
          "default": false
        },
        "disabled": {
          "type": "boolean",
          "default": false
        }
      },
      "style": {
        "raw": {
          "cursor": "pointer",
          "display": "inline-block",
          "background": "rgb(63,63,63)",
          "transition": "background 0.2s"
        },
        "when": [
          {
            "expr": {
              "kind": "ref",
              "path": ["value"],
              "root": "props"
            },
            "apply": {
              "raw": {
                "background": "linear-gradient(rgb(121,88,242), rgb(128,38,255))"
              }
            }
          },
          {
            "expr": {
              "kind": "ref",
              "path": ["disabled"],
              "root": "props"
            },
            "apply": {
              "raw": {
                "cursor": "not-allowed",
                "opacity": "0.5"
              }
            }
          }
        ],
        "radius": {
          "mode": "px",
          "value": 999
        }
      },
      "layout": {
        "width": {
          "mode": "px",
          "value": 36
        },
        "height": {
          "mode": "px",
          "value": 20
        },
        "position": "relative",
        "flexShrink": 0
      },
      "children": [
        {
          "id": "f79",
          "tag": "span",
          "type": "frame",
          "style": {
            "raw": {
              "background": "#fff",
              "box-shadow": "0 1px 3px rgba(0,0,0,0.4)",
              "transition": "left 0.2s"
            },
            "radius": {
              "mode": "px",
              "value": 999
            }
          },
          "layout": {
            "topPx": 3,
            "width": {
              "mode": "px",
              "value": 14
            },
            "height": {
              "mode": "px",
              "value": 14
            },
            "leftPx": 3,
            "position": "absolute"
          },
          "children": [],
          "cssClasses": ["ig-toggle__knob"],
          "layoutMode": "auto",
          "inlineStyleWhen": [
            {
              "expr": {
                "cond": {
                  "kind": "ref",
                  "path": ["value"],
                  "root": "props"
                },
                "else": {
                  "kind": "strLit",
                  "value": "3px"
                },
                "kind": "ternary",
                "then": {
                  "kind": "strLit",
                  "value": "19px"
                }
              },
              "prop": "left"
            }
          ]
        }
      ],
      "triggers": [
        {
          "on": "click",
          "action": "emit",
          "target": "change",
          "payload": {
            "value": "{{!props.value}}"
          },
          "condition": "!props.disabled"
        }
      ],
      "cssClasses": ["ig-toggle"],
      "layoutMode": "auto",
      "cssClassesWhen": [
        {
          "expr": {
            "kind": "ref",
            "path": ["value"],
            "root": "props"
          },
          "class": "ig-toggle--on"
        }
      ]
    },
    "IgTooltip": {
      "id": "Tooltip",
      "tag": "span",
      "name": "Tooltip",
      "type": "frame",
      "props": {
        "text": {
          "type": "string",
          "default": "Подсказка"
        },
        "offset": {
          "type": "number",
          "default": 8
        },
        "maxWidth": {
          "type": "number",
          "default": 320
        },
        "dismissOn": {
          "type": "string",
          "default": "mouseleave"
        },
        "placement": {
          "type": "string",
          "default": "top"
        },
        "triggerOn": {
          "type": "string",
          "default": "mouseenter"
        },
        "interactive": {
          "type": "boolean",
          "default": false
        }
      },
      "style": {
        "raw": {
          "display": "inline-flex",
          "line-height": "1",
          "vertical-align": "middle"
        },
        "hover": {
          "textColor": "rgb(206,255,139)"
        },
        "textColor": "rgb(135,138,146)"
      },
      "layout": {
        "position": "relative",
        "align": "center"
      },
      "children": [
        {
          "id": "tooltip-anchor",
          "tag": "svg",
          "type": "frame",
          "attrs": {
            "fill": "none",
            "role": "button",
            "width": "14",
            "height": "14",
            "viewBox": "0 0 16 16",
            "tabindex": "0",
            "aria-label": "Показать подсказку"
          },
          "style": {
            "raw": {
              "cursor": "help",
              "display": "inline-block",
              "outline": "none",
              "-webkit-tap-highlight-color": "transparent",
              "transition": "color 120ms ease, transform 120ms ease"
            },
            "hover": {
              "raw": {
                "transform": "scale(1.06)"
              }
            },
            "focus": {
              "raw": {
                "outline": "none"
              }
            }
          },
          "layout": {},
          "children": [
            {
              "id": "f3",
              "tag": "circle",
              "type": "frame",
              "attrs": {
                "r": "6.5",
                "cx": "8",
                "cy": "8",
                "stroke": "currentColor",
                "stroke-width": "1.2"
              },
              "layout": {},
              "children": [],
              "layoutMode": "auto"
            },
            {
              "id": "f4",
              "tag": "path",
              "type": "frame",
              "attrs": {
                "d": "M6.5 6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5c0 .9-1.5 1.1-1.5 2.2",
                "stroke": "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round"
              },
              "layout": {},
              "children": [],
              "layoutMode": "auto"
            },
            {
              "id": "f5",
              "tag": "circle",
              "type": "frame",
              "attrs": {
                "r": ".7",
                "cx": "8",
                "cy": "11.5",
                "fill": "currentColor"
              },
              "layout": {},
              "children": [],
              "layoutMode": "auto"
            }
          ],
          "cssClasses": ["tooltip-anchor"],
          "layoutMode": "auto"
        },
        {
          "id": "tooltip-pop",
          "tag": "div",
          "text": "{{props.text}}",
          "type": "overlay",
          "attrs": {
            "role": "tooltip"
          },
          "style": {
            "raw": {
              "background": "#323232",
              "box-shadow": "0 6px 20px rgba(0,0,0,0.35), 0 1px 2px rgba(0,0,0,0.4)",
              "word-break": "normal",
              "overflow-wrap": "break-word",
              "white-space": "pre-line",
              "line-height": "1.35",
              "pointer-events": "{{ props.interactive || props.triggerOn !== 'mouseenter' ? 'auto' : 'none' }}"
            },
            "when": [
              {
                "expr": "props.maxWidth <= 200",
                "apply": {
                  "raw": {
                    "max-width": "200px"
                  }
                }
              },
              {
                "expr": "props.maxWidth > 200 && props.maxWidth <= 280",
                "apply": {
                  "raw": {
                    "max-width": "280px"
                  }
                }
              },
              {
                "expr": "props.maxWidth > 280 && props.maxWidth <= 320",
                "apply": {
                  "raw": {
                    "max-width": "320px"
                  }
                }
              },
              {
                "expr": "props.maxWidth > 320 && props.maxWidth <= 400",
                "apply": {
                  "raw": {
                    "max-width": "400px"
                  }
                }
              },
              {
                "expr": "props.maxWidth > 400 && props.maxWidth <= 480",
                "apply": {
                  "raw": {
                    "max-width": "480px"
                  }
                }
              },
              {
                "expr": "props.maxWidth > 480",
                "apply": {
                  "raw": {
                    "max-width": "560px"
                  }
                }
              }
            ],
            "radius": {
              "mode": "px",
              "value": 8
            },
            "fontSize": {
              "mode": "rem",
              "value": 0.75
            },
            "textColor": "#F9F9F9",
            "fontWeight": 500,
            "borderWidthPx": 0,
            "letterSpacing": {
              "mode": "px",
              "value": 0.2
            }
          },
          "layout": {
            "padding": [
              {
                "mode": "px",
                "value": 8
              },
              {
                "mode": "px",
                "value": 16
              }
            ],
            "paddingRem": [0.5, 1, 0.5, 1]
          },
          "children": [],
          "cssClasses": ["tooltip-pop"],
          "layoutMode": "auto",
          "overlayDismiss": {
            "event": "{{props.dismissOn}}",
            "source": "tooltip-anchor",
            "interactive": "{{props.interactive}}"
          },
          "overlayTrigger": {
            "event": "{{props.triggerOn}}",
            "source": "tooltip-anchor"
          },
          "overlayPosition": {
            "anchor": "tooltip-anchor",
            "offset": "{{props.offset}}",
            "placement": "{{props.placement}}"
          },
          "overlayAnimation": "fade"
        }
      ],
      "cssClasses": ["tooltip"],
      "layoutMode": "flow"
    },
    "IgTextarea": {
      "id": "Textarea",
      "on": {
        "change": {
          "value": "{{ emit }}",
          "action": "set",
          "target": "props.value"
        }
      },
      "tag": "div",
      "type": "frame",
      "emits": ["change", "enhance"],
      "props": {
        "value": {
          "type": "string",
          "default": ""
        },
        "placeholder": {
          "type": "string",
          "default": ""
        },
        "invalid": {
          "type": "boolean",
          "default": false
        },
        "aiEnhance": {
          "type": "boolean",
          "default": false
        },
        "enhancing": {
          "type": "boolean",
          "default": false
        },
        "aiEnhanceDisabled": {
          "type": "boolean",
          "default": false
        }
      },
      "state": {
        "enhanceOpen": false
      },
      "layout": {
        "position": "relative"
      },
      "children": [
        {
          "id": "f32",
          "tag": "textarea",
          "text": "{{props.value}}",
          "type": "frame",
          "attrs": {
            "rows": "4",
            "value": "{{props.value}}",
            "placeholder": "{{props.placeholder}}"
          },
          "emits": ["change"],
          "state": {
            "_tmp": ""
          },
          "style": {
            "raw": {
              "resize": "vertical",
              "outline": "none",
              "background": "rgb(50,50,50)",
              "box-sizing": "border-box",
              "transition": "border-color 0.15s",
              "padding-right": "{{ props.aiEnhance ? '44px' : '14px' }}"
            },
            "focus": {
              "borderColor": "rgb(226,137,255)"
            },
            "when": [
              {
                "expr": "props.invalid",
                "apply": {
                  "borderColor": "rgb(251,75,87)",
                  "focus": {
                    "borderColor": "rgb(251,75,87)"
                  }
                }
              }
            ],
            "radius": {
              "mode": "px",
              "value": 10
            },
            "fontSize": {
              "mode": "px",
              "value": 13
            },
            "textColor": "rgb(249,249,249)",
            "fontFamily": "Inter,sans-serif",
            "lineHeight": {
              "mode": "px",
              "value": 19
            },
            "borderColor": "rgb(69,69,69)",
            "borderStyle": "solid",
            "borderWidthPx": 1
          },
          "layout": {
            "width": {
              "mode": "fill"
            },
            "padding": [
              {
                "mode": "px",
                "value": 12
              },
              {
                "mode": "px",
                "value": 14
              }
            ],
            "minHeight": {
              "mode": "px",
              "value": 80
            }
          },
          "children": [],
          "triggers": [
            {
              "on": "input",
              "chain": [
                {
                  "action": "readValue",
                  "target": "#_tmp",
                  "readFrom": "value"
                },
                {
                  "action": "emit",
                  "target": "change",
                  "payload": "{{state._tmp}}"
                }
              ],
              "action": "readValue",
              "target": "#_tmp",
              "readFrom": "value"
            }
          ],
          "cssClasses": ["ig-textarea", "ig-textarea--prompt"],
          "layoutMode": "auto"
        },
        {
          "id": "ig-textarea-enhance",
          "tag": "button",
          "type": "frame",
          "visibleWhen": "props.aiEnhance === true",
          "attrs": {
            "title": "Enhance with AI"
          },
          "style": {
            "radius": {
              "mode": "px",
              "value": 999
            },
            "borderWidthPx": 0,
            "textColor": "rgb(255,255,255)",
            "raw": {
              "cursor": "pointer",
              "background": "radial-gradient(circle at 30% 30%,rgb(255,159,50),rgb(216,98,7))",
              "box-shadow": "rgba(255,159,50,0.16) 0px 0px 0px 5px"
            },
            "when": [
              {
                "expr": "props.enhancing",
                "apply": {
                  "raw": {
                    "opacity": "0.6",
                    "pointer-events": "none"
                  }
                }
              },
              {
                "expr": "props.aiEnhanceDisabled",
                "apply": {
                  "raw": {
                    "opacity": "0.45",
                    "cursor": "not-allowed",
                    "pointer-events": "none"
                  }
                }
              }
            ]
          },
          "layout": {
            "position": "absolute",
            "rightPx": 10,
            "bottomPx": 10,
            "width": {
              "mode": "px",
              "value": 28
            },
            "height": {
              "mode": "px",
              "value": 28
            },
            "align": "center",
            "justify": "center"
          },
          "triggers": [
            {
              "on": "click",
              "action": "toggle",
              "target": "#enhanceOpen",
              "condition": "!props.enhancing && !props.aiEnhanceDisabled"
            }
          ],
          "cssClasses": ["ig-textarea__enhance"],
          "layoutMode": "flow",
          "children": [
            {
              "id": "ig-textarea-enhance-icon",
              "tag": "svg",
              "type": "frame",
              "visibleWhen": "!props.enhancing",
              "attrs": {
                "width": "14",
                "height": "14",
                "viewBox": "0 0 16 16",
                "fill": "none"
              },
              "cssClasses": ["ig-textarea__enhance-icon"],
              "layoutMode": "auto",
              "layout": {},
              "children": [
                {
                  "id": "ig-textarea-enhance-wand",
                  "tag": "path",
                  "type": "frame",
                  "layoutMode": "auto",
                  "layout": {},
                  "children": [],
                  "attrs": {
                    "d": "M3 13l6-6m1.5-1.5l1.5-1.5M13 8l1 .5L13 9l-.5 1L12 9l-1-.5L12 8l.5-1L13 8z",
                    "stroke": "currentColor",
                    "stroke-width": "1.4",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                {
                  "id": "ig-textarea-enhance-spark",
                  "tag": "path",
                  "type": "frame",
                  "layoutMode": "auto",
                  "layout": {},
                  "children": [],
                  "attrs": {
                    "d": "M13 2.5l.4 1.1L14.5 4l-1.1.4L13 5.5l-.4-1.1L11.5 4l1.1-.4L13 2.5z",
                    "fill": "currentColor"
                  }
                }
              ]
            },
            {
              "id": "ig-textarea-enhance-spinner",
              "tag": "svg",
              "type": "frame",
              "visibleWhen": "props.enhancing",
              "attrs": {
                "width": "14",
                "height": "14",
                "viewBox": "0 0 16 16",
                "fill": "none"
              },
              "cssClasses": ["ig-textarea__enhance-spinner"],
              "layoutMode": "auto",
              "layout": {},
              "children": [
                {
                  "id": "ig-textarea-enhance-spinner-track",
                  "tag": "circle",
                  "type": "frame",
                  "layoutMode": "auto",
                  "layout": {},
                  "children": [],
                  "attrs": {
                    "cx": "8",
                    "cy": "8",
                    "r": "6",
                    "stroke": "currentColor",
                    "stroke-width": "2",
                    "stroke-opacity": "0.3"
                  }
                },
                {
                  "id": "ig-textarea-enhance-spinner-arc",
                  "tag": "path",
                  "type": "frame",
                  "layoutMode": "auto",
                  "layout": {},
                  "attrs": {
                    "d": "M14 8a6 6 0 0 0-6-6",
                    "stroke": "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round"
                  },
                  "children": [
                    {
                      "id": "ig-textarea-enhance-spinner-anim",
                      "tag": "animateTransform",
                      "type": "frame",
                      "layoutMode": "auto",
                      "layout": {},
                      "children": [],
                      "attrs": {
                        "attributeName": "transform",
                        "attributeType": "XML",
                        "type": "rotate",
                        "from": "0 8 8",
                        "to": "360 8 8",
                        "dur": "0.6s",
                        "repeatCount": "indefinite"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "ig-textarea-enhance-menu",
          "tag": "div",
          "type": "overlay",
          "overlayTrigger": {
            "event": "state",
            "stateKey": "state.enhanceOpen"
          },
          "overlayDismiss": {
            "event": "escape"
          },
          "overlayBackdrop": {
            "color": "transparent",
            "clickDismiss": true
          },
          "overlayPosition": {
            "anchor": "ig-textarea-enhance",
            "offset": 8,
            "placement": "top-end"
          },
          "style": {
            "backgroundColor": "rgb(60,60,60)",
            "borderColor": "rgb(69,69,69)",
            "borderStyle": "solid",
            "borderWidthPx": 1,
            "radius": {
              "mode": "px",
              "value": 10
            },
            "raw": {
              "box-shadow": "0 8px 24px rgba(0,0,0,0.5)"
            }
          },
          "layout": {
            "width": {
              "mode": "px",
              "value": 240
            },
            "padding": {
              "mode": "px",
              "value": 4
            },
            "direction": "column"
          },
          "cssClasses": ["ig-textarea__enhance-menu"],
          "layoutMode": "flow",
          "children": [
            {
              "id": "ig-textarea-enhance-menu-title",
              "tag": "div",
              "type": "frame",
              "text": "Enhance prompt",
              "style": {
                "textColor": "rgb(135,138,146)",
                "fontFamily": "Inter,sans-serif",
                "fontSize": {
                  "mode": "px",
                  "value": 10
                },
                "fontWeight": 700,
                "textTransform": "uppercase",
                "letterSpacingPx": 0.6
              },
              "layout": {
                "padding": [
                  {
                    "mode": "px",
                    "value": 8
                  },
                  {
                    "mode": "px",
                    "value": 10
                  },
                  {
                    "mode": "px",
                    "value": 4
                  },
                  {
                    "mode": "px",
                    "value": 10
                  }
                ]
              },
              "cssClasses": ["ig-textarea__enhance-menu-title"],
              "layoutMode": "auto",
              "children": []
            },
            {
              "id": "ig-textarea-enhance-opt-natural",
              "tag": "button",
              "type": "frame",
              "style": {
                "radius": {
                  "mode": "px",
                  "value": 6
                },
                "borderWidthPx": 0,
                "textAlign": "left",
                "raw": {
                  "cursor": "pointer",
                  "background": "transparent"
                },
                "hover": {
                  "backgroundColor": "#545456"
                }
              },
              "layout": {
                "width": {
                  "mode": "fill"
                },
                "gap": {
                  "mode": "px",
                  "value": 2
                },
                "padding": [
                  {
                    "mode": "px",
                    "value": 8
                  },
                  {
                    "mode": "px",
                    "value": 10
                  }
                ],
                "direction": "column"
              },
              "triggers": [
                {
                  "on": "click",
                  "action": "emit",
                  "target": "enhance",
                  "payload": {
                    "enhanceStyle": "natural"
                  },
                  "chain": [
                    {
                      "action": "emit",
                      "target": "enhance",
                      "payload": {
                        "enhanceStyle": "natural"
                      }
                    },
                    {
                      "action": "set",
                      "target": "#enhanceOpen",
                      "value": false
                    }
                  ]
                }
              ],
              "cssClasses": ["ig-textarea__enhance-opt"],
              "layoutMode": "flow",
              "children": [
                {
                  "id": "ig-textarea-enhance-opt-natural-title",
                  "tag": "span",
                  "type": "frame",
                  "text": "Natural language",
                  "style": {
                    "textColor": "rgb(249,249,249)",
                    "fontFamily": "Inter,sans-serif",
                    "fontSize": {
                      "mode": "px",
                      "value": 13
                    },
                    "fontWeight": 500
                  },
                  "layout": {},
                  "layoutMode": "auto",
                  "children": []
                },
                {
                  "id": "ig-textarea-enhance-opt-natural-desc",
                  "tag": "span",
                  "type": "frame",
                  "text": "Rewrite as a vivid description",
                  "style": {
                    "textColor": "rgb(135,138,146)",
                    "fontFamily": "Inter,sans-serif",
                    "fontSize": {
                      "mode": "px",
                      "value": 11
                    }
                  },
                  "layout": {},
                  "layoutMode": "auto",
                  "children": []
                }
              ]
            },
            {
              "id": "ig-textarea-enhance-opt-tags",
              "tag": "button",
              "type": "frame",
              "style": {
                "radius": {
                  "mode": "px",
                  "value": 6
                },
                "borderWidthPx": 0,
                "textAlign": "left",
                "raw": {
                  "cursor": "pointer",
                  "background": "transparent"
                },
                "hover": {
                  "backgroundColor": "#545456"
                }
              },
              "layout": {
                "width": {
                  "mode": "fill"
                },
                "gap": {
                  "mode": "px",
                  "value": 2
                },
                "padding": [
                  {
                    "mode": "px",
                    "value": 8
                  },
                  {
                    "mode": "px",
                    "value": 10
                  }
                ],
                "direction": "column"
              },
              "triggers": [
                {
                  "on": "click",
                  "action": "emit",
                  "target": "enhance",
                  "payload": {
                    "enhanceStyle": "danbooru"
                  },
                  "chain": [
                    {
                      "action": "emit",
                      "target": "enhance",
                      "payload": {
                        "enhanceStyle": "danbooru"
                      }
                    },
                    {
                      "action": "set",
                      "target": "#enhanceOpen",
                      "value": false
                    }
                  ]
                }
              ],
              "cssClasses": ["ig-textarea__enhance-opt"],
              "layoutMode": "flow",
              "children": [
                {
                  "id": "ig-textarea-enhance-opt-tags-title",
                  "tag": "span",
                  "type": "frame",
                  "text": "Tag-based",
                  "style": {
                    "textColor": "rgb(249,249,249)",
                    "fontFamily": "Inter,sans-serif",
                    "fontSize": {
                      "mode": "px",
                      "value": 13
                    },
                    "fontWeight": 500
                  },
                  "layout": {},
                  "layoutMode": "auto",
                  "children": []
                },
                {
                  "id": "ig-textarea-enhance-opt-tags-desc",
                  "tag": "span",
                  "type": "frame",
                  "text": "Convert to comma-separated tags",
                  "style": {
                    "textColor": "rgb(135,138,146)",
                    "fontFamily": "Inter,sans-serif",
                    "fontSize": {
                      "mode": "px",
                      "value": 11
                    }
                  },
                  "layout": {},
                  "layoutMode": "auto",
                  "children": []
                }
              ]
            }
          ]
        }
      ],
      "cssClasses": ["ig-textarea-wrap"],
      "layoutMode": "auto",
      "__changeKey": "value"
    },
    "StyleCard": {
      "id": "StyleCard",
      "tag": "button",
      "type": "frame",
      "emits": ["emit-1"],
      "props": {
        "title": {
          "type": "string",
          "default": "Anime"
        },
        "selectedValue": {
          "type": "string",
          "default": ""
        }
      },
      "style": {
        "raw": {
          "cursor": "pointer",
          "background": "transparent"
        },
        "borderWidthPx": 0
      },
      "layout": {
        "gap": {
          "mode": "px",
          "value": 6
        },
        "align": "center",
        "width": {
          "mode": "fill"
        },
        "padding": {
          "mode": "px",
          "value": 0
        },
        "minWidth": {
          "mode": "px",
          "value": 0
        },
        "direction": "column"
      },
      "children": [
        {
          "id": "f51",
          "tag": "span",
          "type": "frame",
          "style": {
            "raw": {
              "outline": "rgb(69,69,69) solid 2px",
              "outline-offset": "0px",
              "transition": "outline-color 0.15s",
              "aspect-ratio": "1/1",
              "background-size": "cover",
              "background-color": "rgb(50,50,50)",
              "background-image": "url(https://api.dicebear.com/9.x/adventurer-neutral/svg?seed={{props.title}})",
              "background-repeat": "no-repeat",
              "background-position": "center"
            },
            "when": [
              {
                "expr": "props.selectedValue === props.title",
                "apply": {
                  "raw": {
                    "outline": "rgb(226,137,255) solid 2px",
                    "outline-offset": "1px"
                  }
                }
              }
            ],
            "radius": {
              "mode": "px",
              "value": 8
            }
          },
          "layout": {
            "width": {
              "mode": "fill"
            }
          },
          "children": [],
          "overflow": "hidden",
          "cssClasses": ["ig-style-card__thumb"],
          "layoutMode": "auto"
        },
        {
          "id": "f52",
          "tag": "span",
          "text": "{{props.title}}",
          "type": "frame",
          "style": {
            "raw": {
              "white-space": "nowrap",
              "text-overflow": "ellipsis"
            },
            "when": [
              {
                "expr": "props.selectedValue === props.title",
                "apply": {
                  "textColor": "rgb(249,249,249)",
                  "fontWeight": 600
                }
              }
            ],
            "fontSize": {
              "mode": "px",
              "value": 11
            },
            "textColor": "rgb(180,182,190)",
            "fontFamily": "Inter",
            "fontWeight": 400,
            "lineHeight": {
              "mode": "px",
              "value": 14
            }
          },
          "layout": {
            "maxWidth": {
              "mode": "percent",
              "value": 100
            }
          },
          "children": [],
          "overflow": "hidden",
          "cssClasses": ["ig-style-card__label"],
          "layoutMode": "auto"
        }
      ],
      "triggers": [
        {
          "on": "click",
          "value": "{{props.title}}",
          "action": "emit",
          "target": "emit-1"
        }
      ],
      "cssClasses": ["ig-style-card"],
      "layoutMode": "flow"
    },
    "ImageModal": {
      "id": "ImageModal",
      "css": ".image-modal[__sc__]{background:#000;width:100vw;height:100vh}\n.header[__sc__]{border-bottom:1px solid rgba(255,255,255,0.08)}\n.chip[__sc__]{font-family:Inter;font-size:13px;color:rgb(180,182,190)}\n.dot[__sc__]{font-family:Inter;font-size:13px;color:rgb(135,138,146)}\n.header-chips[__sc__]{display:flex;flex-direction:row;align-items:center;gap:10px;flex-wrap:wrap}\n.header-actions[__sc__]{margin-left:auto;display:flex;flex-direction:row;align-items:center;gap:8px}\n@media (max-width:768px){.header-actions[__sc__]{margin-left:0;width:100%;justify-content:flex-start}.header-chips[__sc__]{width:100%}}\n.btn-pill[__sc__]{cursor:pointer;background:transparent;font-family:Inter;font-size:12px;font-weight:600;color:rgb(180,182,190);border:1px solid rgb(69,69,69);border-radius:8px;text-decoration:none;transition:transform 0.08s,filter 0.15s,border-color 0.15s,background 0.15s}\n.btn-pill[__sc__]:hover{background:rgba(255,255,255,0.06)}\n.btn-pill--push[__sc__]{margin-left:auto}\n.btn-icon[__sc__]{cursor:pointer;background:rgb(50,50,50);color:rgb(249,249,249);border:1px solid rgb(69,69,69);border-radius:6px;transition:background 0.15s}\n.btn-icon[__sc__]:hover{background:rgb(63,63,63)}\n.body[__sc__]{flex:1 1 0%}\n.image-pane[__sc__]{flex:1 1 0%}\n.image[__sc__]{object-fit:contain;box-shadow:rgba(0,0,0,0.6) 0 8px 40px;border-radius:8px}\n.sidebar[__sc__]{background:rgb(43,43,43);border-left:1px solid rgb(69,69,69);overflow-y:auto}\n.meta-title[__sc__]{font-family:Inter;font-size:13px;line-height:18px;font-weight:500;color:rgb(249,249,249)}\n.meta-card[__sc__]{background:rgb(50,50,50);border:1px solid rgb(69,69,69);border-radius:10px}\n.meta-label[__sc__]{font-family:Inter;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.6px;color:rgb(135,138,146)}\n.meta-value[__sc__]{font-family:Inter;font-size:13px;line-height:19px;color:rgb(249,249,249)}\n.meta-value--muted[__sc__]{color:rgb(180,182,190)}\n.meta-divider[__sc__]{background:rgb(69,69,69)}\n.meta-grid[__sc__]{display:grid;grid-template-columns:repeat(2,1fr)}\n.cell-label[__sc__]{font-family:Inter;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.4px;color:rgb(135,138,146)}\n.cell-value[__sc__]{font-family:Inter;font-size:13px;font-weight:500;color:rgb(249,249,249);text-overflow:ellipsis;white-space:nowrap}",
      "tag": "div",
      "name": "ImageModal",
      "type": "frame",
      "emits": ["useAsBase", "download", "delete", "copyParams", "close"],
      "state": {
        "dateLabel": ""
      },
      "script": "function setup(component){function fmt(ts){if(ts==null||ts==='')return '';var n=Number(ts);if(!Number.isFinite(n)||n<=0)return String(ts);var d=new Date(n);if(isNaN(d.getTime()))return String(ts);var p=function(x){return String(x).padStart(2,'0');};return p(d.getDate())+'.'+p(d.getMonth()+1)+'.'+d.getFullYear()+' '+p(d.getHours())+':'+p(d.getMinutes());}function apply(ts){var l=fmt(ts);if(component.state.dateLabel!==l)component.state.dateLabel=l;}apply(component.props.date);component.watch(function(){return component.props.date;},apply);}",
      "props": {
        "date": {
          "type": "string",
          "default": "17.07.2025 12:04"
        },
        "seed": {
          "type": "number",
          "default": 5612043
        },
        "model": {
          "type": "string",
          "default": "Anime SDXL v1.2.1"
        },
        "steps": {
          "type": "number",
          "default": 35
        },
        "style": {
          "type": "string",
          "default": "Cyberpunk"
        },
        "aspect": {
          "type": "string",
          "default": "3:4"
        },
        "prompt": {
          "type": "string",
          "default": "Neon-lit cyberpunk alley in Tokyo, rain, reflections, 35mm film"
        },
        "sampler": {
          "type": "string",
          "default": ""
        },
        "cfgScale": {
          "type": "number",
          "default": 8
        },
        "imageSrc": {
          "type": "string",
          "default": ""
        },
        "negative": {
          "type": "string",
          "default": "blur, lowres"
        },
        "scheduler": {
          "type": "string",
          "default": ""
        }
      },
      "style": {},
      "layout": {
        "padding": {
          "mode": "px",
          "value": 0
        },
        "position": "relative",
        "direction": "column"
      },
      "children": [
        {
          "id": "header-mobile",
          "tag": "div",
          "type": "frame",
          "style": {
            "raw": {
              "display": "none"
            }
          },
          "layout": {
            "align": "center",
            "gap": {
              "mode": "px",
              "value": 8
            },
            "direction": "row",
            "padding": [
              {
                "mode": "px",
                "value": 12
              },
              {
                "mode": "px",
                "value": 12
              },
              {
                "mode": "px",
                "value": 0
              },
              {
                "mode": "px",
                "value": 12
              }
            ],
            "flexShrink": 0
          },
          "responsive": {
            "sm": {
              "hidden": false,
              "styleRaw": {
                "display": "flex"
              }
            }
          },
          "children": [
            {
              "id": "btn-close-mobile",
              "tag": "button",
              "type": "frame",
              "attrs": {
                "type": "button",
                "aria-label": "Close"
              },
              "style": {
                "raw": {
                  "border-radius": "999px",
                  "background": "rgba(255,255,255,0.08)",
                  "border": "0",
                  "color": "rgb(255,255,255)",
                  "cursor": "pointer"
                }
              },
              "layout": {
                "align": "center",
                "justify": "center",
                "width": {
                  "mode": "px",
                  "value": 36
                },
                "height": {
                  "mode": "px",
                  "value": 36
                },
                "flexShrink": 0
              },
              "children": [
                {
                  "id": "icon-close-mobile",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "16",
                    "height": "16",
                    "viewBox": "0 0 16 16"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "icon-close-mobile-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M4 4l8 8M12 4l-8 8",
                        "stroke": "currentColor",
                        "stroke-width": "1.6",
                        "stroke-linecap": "round"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "auto"
                }
              ],
              "triggers": [
                {
                  "on": "click",
                  "action": "emit",
                  "target": "close"
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "header-mobile-date",
              "tag": "span",
              "type": "frame",
              "text": "{{state.dateLabel}}",
              "style": {
                "raw": {
                  "font-family": "Inter",
                  "font-size": "12px",
                  "color": "rgba(255,255,255,0.6)"
                }
              },
              "layout": {},
              "children": [],
              "layoutMode": "flow"
            },
            {
              "id": "header-mobile-actions",
              "tag": "div",
              "type": "frame",
              "style": {
                "raw": {
                  "margin-left": "auto"
                }
              },
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 6
                },
                "direction": "row"
              },
              "children": [
                {
                  "id": "btn-download-mobile",
                  "tag": "a",
                  "type": "frame",
                  "attrs": {
                    "rel": "noopener",
                    "href": "{{props.imageSrc}}",
                    "target": "_blank",
                    "download": "{{ props.date ? props.date + '.png' : 'image.png' }}",
                    "aria-label": "Download"
                  },
                  "style": {
                    "raw": {
                      "border-radius": "999px",
                      "background": "rgba(255,255,255,0.08)",
                      "color": "rgb(255,255,255)",
                      "cursor": "pointer",
                      "text-decoration": "none"
                    }
                  },
                  "layout": {
                    "align": "center",
                    "justify": "center",
                    "width": {
                      "mode": "px",
                      "value": 36
                    },
                    "height": {
                      "mode": "px",
                      "value": 36
                    },
                    "flexShrink": 0
                  },
                  "children": [
                    {
                      "id": "icon-download-mobile",
                      "tag": "svg",
                      "type": "frame",
                      "attrs": {
                        "fill": "none",
                        "width": "14",
                        "height": "14",
                        "viewBox": "0 0 16 16"
                      },
                      "layout": {},
                      "children": [
                        {
                          "id": "icon-download-mobile-path",
                          "tag": "path",
                          "type": "frame",
                          "attrs": {
                            "d": "M8 2v8m-3-3l3 3 3-3M3 13h10",
                            "stroke": "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          },
                          "layout": {},
                          "children": [],
                          "layoutMode": "auto"
                        }
                      ],
                      "layoutMode": "auto"
                    }
                  ],
                  "triggers": [],
                  "layoutMode": "flow"
                },
                {
                  "id": "btn-delete-mobile",
                  "tag": "button",
                  "type": "frame",
                  "attrs": {
                    "type": "button",
                    "aria-label": "Delete"
                  },
                  "style": {
                    "raw": {
                      "border-radius": "999px",
                      "background": "rgba(255,255,255,0.08)",
                      "border": "0",
                      "color": "rgb(255,255,255)",
                      "cursor": "pointer"
                    }
                  },
                  "layout": {
                    "align": "center",
                    "justify": "center",
                    "width": {
                      "mode": "px",
                      "value": 36
                    },
                    "height": {
                      "mode": "px",
                      "value": 36
                    },
                    "flexShrink": 0
                  },
                  "children": [
                    {
                      "id": "icon-delete-mobile",
                      "tag": "svg",
                      "type": "frame",
                      "attrs": {
                        "fill": "none",
                        "width": "14",
                        "height": "14",
                        "viewBox": "0 0 16 16"
                      },
                      "layout": {},
                      "children": [
                        {
                          "id": "icon-delete-mobile-path",
                          "tag": "path",
                          "type": "frame",
                          "attrs": {
                            "d": "M3 4.5h10M6 4.5V3a1 1 0 011-1h2a1 1 0 011 1v1.5M5 4.5l.5 8.5a1 1 0 001 1h3a1 1 0 001-1l.5-8.5",
                            "stroke": "currentColor",
                            "stroke-width": "1.4",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          },
                          "layout": {},
                          "children": [],
                          "layoutMode": "auto"
                        }
                      ],
                      "layoutMode": "auto"
                    }
                  ],
                  "triggers": [
                    {
                      "on": "click",
                      "value": "{{props.imageSrc}}",
                      "action": "set",
                      "target": "$_confirmDeleteTarget"
                    },
                    {
                      "on": "click",
                      "value": true,
                      "action": "set",
                      "target": "$_confirmDeleteOpen"
                    }
                  ],
                  "layoutMode": "flow"
                }
              ],
              "layoutMode": "flow"
            }
          ],
          "layoutMode": "flow"
        },
        {
          "id": "header",
          "tag": "div",
          "type": "frame",
          "layout": {
            "gap": {
              "mode": "px",
              "value": 16
            },
            "align": "center",
            "height": {
              "mode": "px",
              "value": 56
            },
            "padding": [
              {
                "mode": "px",
                "value": 0
              },
              {
                "mode": "px",
                "value": 56
              },
              {
                "mode": "px",
                "value": 0
              },
              {
                "mode": "px",
                "value": 20
              }
            ],
            "position": "relative",
            "flexShrink": 0
          },
          "children": [
            {
              "id": "header-chips",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 10
                },
                "align": "center"
              },
              "children": [
                {
                  "id": "header-date",
                  "tag": "span",
                  "text": "{{state.dateLabel || '—'}}",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["chip"],
                  "layoutMode": "auto"
                },
                {
                  "id": "dot-1",
                  "tag": "span",
                  "text": "·",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["dot"],
                  "layoutMode": "auto",
                  "responsive": {
                    "md": {
                      "hidden": true
                    }
                  }
                },
                {
                  "id": "header-model",
                  "tag": "span",
                  "text": "{{props.model || '—'}}",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["chip"],
                  "layoutMode": "auto"
                },
                {
                  "id": "dot-2",
                  "tag": "span",
                  "text": "·",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["dot"],
                  "layoutMode": "auto",
                  "responsive": {
                    "md": {
                      "hidden": true
                    }
                  }
                },
                {
                  "id": "header-aspect",
                  "tag": "span",
                  "text": "{{props.aspect || '—'}}",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "cssClasses": ["chip"],
                  "layoutMode": "auto"
                }
              ],
              "cssClasses": ["header-chips"],
              "layoutMode": "flow"
            },
            {
              "id": "header-actions",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 8
                }
              },
              "children": [
                {
                  "id": "btn-download",
                  "tag": "a",
                  "type": "frame",
                  "attrs": {
                    "rel": "noopener",
                    "href": "{{props.imageSrc}}",
                    "target": "_blank",
                    "download": "{{ props.date ? props.date + '.png' : 'image.png' }}"
                  },
                  "layout": {
                    "gap": {
                      "mode": "px",
                      "value": 6
                    },
                    "align": "center",
                    "width": {
                      "mode": "auto"
                    },
                    "height": {
                      "mode": "px",
                      "value": 30
                    },
                    "justify": "center",
                    "padding": [
                      {
                        "mode": "px",
                        "value": 0
                      },
                      {
                        "mode": "px",
                        "value": 10
                      }
                    ]
                  },
                  "children": [
                    {
                      "id": "icon-download",
                      "tag": "svg",
                      "type": "frame",
                      "attrs": {
                        "fill": "none",
                        "width": "14",
                        "height": "14",
                        "viewBox": "0 0 16 16"
                      },
                      "layout": {},
                      "children": [
                        {
                          "id": "icon-download-path",
                          "tag": "path",
                          "type": "frame",
                          "attrs": {
                            "d": "M8 2v8m-3-3l3 3 3-3M3 13h10",
                            "stroke": "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          },
                          "layout": {},
                          "children": [],
                          "layoutMode": "auto"
                        }
                      ],
                      "layoutMode": "auto"
                    },
                    {
                      "id": "btn-download-label",
                      "text": "Download",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "layoutMode": "auto",
                      "tag": "div"
                    }
                  ],
                  "triggers": [],
                  "cssClasses": ["btn-pill"],
                  "layoutMode": "flow"
                },
                {
                  "id": "delete-gallery-image-btn",
                  "tag": "button",
                  "type": "frame",
                  "layout": {
                    "gap": {
                      "mode": "px",
                      "value": 6
                    },
                    "align": "center",
                    "width": {
                      "mode": "auto"
                    },
                    "height": {
                      "mode": "px",
                      "value": 30
                    },
                    "justify": "center",
                    "padding": [
                      {
                        "mode": "px",
                        "value": 0
                      },
                      {
                        "mode": "px",
                        "value": 10
                      }
                    ]
                  },
                  "children": [
                    {
                      "id": "icon-delete",
                      "tag": "svg",
                      "type": "frame",
                      "attrs": {
                        "fill": "none",
                        "width": "14",
                        "height": "14",
                        "viewBox": "0 0 16 16"
                      },
                      "layout": {},
                      "children": [
                        {
                          "id": "icon-delete-path",
                          "tag": "path",
                          "type": "frame",
                          "attrs": {
                            "d": "M3 4.5h10M6 4.5V3a1 1 0 011-1h2a1 1 0 011 1v1.5M5 4.5l.5 8.5a1 1 0 001 1h3a1 1 0 001-1l.5-8.5",
                            "stroke": "currentColor",
                            "stroke-width": "1.4",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          },
                          "layout": {},
                          "children": [],
                          "layoutMode": "auto"
                        }
                      ],
                      "layoutMode": "auto"
                    },
                    {
                      "id": "btn-delete-label",
                      "text": "Delete",
                      "type": "frame",
                      "layout": {},
                      "children": [],
                      "layoutMode": "auto",
                      "tag": "div"
                    }
                  ],
                  "triggers": [
                    {
                      "on": "click",
                      "value": "{{props.imageSrc}}",
                      "action": "set",
                      "target": "$_confirmDeleteTarget"
                    },
                    {
                      "on": "click",
                      "value": true,
                      "action": "set",
                      "target": "$_confirmDeleteOpen"
                    }
                  ],
                  "cssClasses": ["btn-pill"],
                  "layoutMode": "flow"
                },
                {
                  "id": "btn-close",
                  "tag": "button",
                  "type": "frame",
                  "layout": {
                    "align": "center",
                    "topPx": 12,
                    "width": {
                      "mode": "px",
                      "value": 32
                    },
                    "height": {
                      "mode": "px",
                      "value": 32
                    },
                    "justify": "center",
                    "rightPx": 12,
                    "position": "absolute"
                  },
                  "children": [
                    {
                      "id": "icon-close",
                      "tag": "svg",
                      "type": "frame",
                      "attrs": {
                        "fill": "none",
                        "width": "16",
                        "height": "16",
                        "viewBox": "0 0 16 16"
                      },
                      "layout": {},
                      "children": [
                        {
                          "id": "icon-close-path",
                          "tag": "path",
                          "type": "frame",
                          "attrs": {
                            "d": "M4 4l8 8M12 4l-8 8",
                            "stroke": "currentColor",
                            "stroke-width": "1.6",
                            "stroke-linecap": "round"
                          },
                          "layout": {},
                          "children": [],
                          "layoutMode": "auto"
                        }
                      ],
                      "layoutMode": "auto"
                    }
                  ],
                  "triggers": [
                    {
                      "on": "click",
                      "action": "emit",
                      "target": "close"
                    }
                  ],
                  "cssClasses": ["btn-icon"],
                  "layoutMode": "flow"
                }
              ],
              "cssClasses": ["header-actions"],
              "layoutMode": "flow"
            }
          ],
          "cssClasses": ["header"],
          "layoutMode": "flow",
          "responsive": {
            "md": {
              "gap": {
                "mode": "px",
                "value": 10
              },
              "padding": [
                {
                  "mode": "px",
                  "value": 0
                },
                {
                  "mode": "px",
                  "value": 56
                },
                {
                  "mode": "px",
                  "value": 0
                },
                {
                  "mode": "px",
                  "value": 12
                }
              ]
            },
            "sm": {
              "gap": {
                "mode": "px",
                "value": 10
              },
              "align": "stretch",
              "height": {
                "mode": "auto"
              },
              "padding": [
                {
                  "mode": "px",
                  "value": 12
                },
                {
                  "mode": "px",
                  "value": 56
                },
                {
                  "mode": "px",
                  "value": 12
                },
                {
                  "mode": "px",
                  "value": 12
                }
              ],
              "direction": "column",
              "hidden": true
            }
          }
        },
        {
          "id": "body",
          "tag": "div",
          "type": "frame",
          "layout": {
            "minHeight": {
              "mode": "px",
              "value": 0
            }
          },
          "children": [
            {
              "id": "image-pane",
              "tag": "div",
              "type": "frame",
              "layout": {
                "align": "center",
                "justify": "center",
                "padding": {
                  "mode": "px",
                  "value": 24
                },
                "minWidth": {
                  "mode": "px",
                  "value": 0
                },
                "minHeight": {
                  "mode": "px",
                  "value": 0
                }
              },
              "children": [
                {
                  "id": "image",
                  "tag": "img",
                  "type": "frame",
                  "visibleWhen": "!!props.imageSrc",
                  "attrs": {
                    "alt": "",
                    "src": "{{props.imageSrc}}"
                  },
                  "layout": {
                    "maxWidth": {
                      "mode": "percent",
                      "value": 100
                    },
                    "maxHeight": {
                      "mode": "percent",
                      "value": 100
                    }
                  },
                  "children": [],
                  "cssClasses": ["image"],
                  "layoutMode": "auto"
                },
                {
                  "id": "image-placeholder",
                  "tag": "div",
                  "type": "frame",
                  "text": "Image unavailable",
                  "visibleWhen": "!props.imageSrc",
                  "style": {
                    "raw": {
                      "color": "rgb(135,138,146)",
                      "font-size": "13px",
                      "text-align": "center"
                    }
                  },
                  "layout": {
                    "paddingRem": 1.5
                  },
                  "children": [],
                  "layoutMode": "flow"
                }
              ],
              "cssClasses": ["image-pane"],
              "layoutMode": "flow",
              "responsive": {
                "md": {
                  "padding": {
                    "mode": "px",
                    "value": 12
                  }
                }
              }
            },
            {
              "id": "sidebar",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gap": {
                  "mode": "px",
                  "value": 16
                },
                "width": {
                  "mode": "px",
                  "value": 380
                },
                "padding": {
                  "mode": "px",
                  "value": 20
                },
                "direction": "column",
                "flexShrink": 0
              },
              "children": [
                {
                  "id": "sidebar-meta-panel",
                  "ref": "ImageMetaPanel",
                  "type": "frame",
                  "props": {
                    "prompt": "{{props.prompt}}",
                    "negative": "{{props.negative}}",
                    "model": "{{props.model}}",
                    "style": "{{props.style}}",
                    "aspect": "{{props.aspect}}",
                    "cfgScale": "{{props.cfgScale}}",
                    "steps": "{{props.steps}}",
                    "seed": "{{props.seed}}",
                    "sampler": "{{props.sampler}}",
                    "scheduler": "{{props.scheduler}}"
                  },
                  "on": {
                    "close": {
                      "action": "emit",
                      "target": "close"
                    }
                  },
                  "layout": {},
                  "children": [],
                  "layoutMode": "flow",
                  "tag": "div"
                }
              ],
              "cssClasses": ["sidebar"],
              "layoutMode": "flow",
              "responsive": {
                "md": {
                  "width": {
                    "mode": "percent",
                    "value": 100
                  },
                  "padding": {
                    "mode": "px",
                    "value": 16
                  }
                },
                "sm": {
                  "hidden": true
                }
              }
            }
          ],
          "cssClasses": ["body"],
          "layoutMode": "flow",
          "responsive": {
            "md": {
              "direction": "column"
            },
            "sm": {
              "direction": "column"
            }
          }
        },
        {
          "id": "bottom-bar-mobile",
          "tag": "div",
          "type": "frame",
          "style": {
            "raw": {
              "border-top": "1px solid rgba(255,255,255,0.08)",
              "background": "rgba(0,0,0,0.6)",
              "display": "none"
            }
          },
          "layout": {
            "paddingRem": [0.625, 0.875, 1.5, 0.875],
            "gapRem": 0.5,
            "align": "center",
            "flexShrink": 0
          },
          "responsive": {
            "sm": {
              "hidden": false,
              "styleRaw": {
                "display": "flex"
              }
            }
          },
          "children": [
            {
              "id": "btn-use-as-base-mobile",
              "tag": "button",
              "type": "frame",
              "attrs": {
                "type": "button"
              },
              "style": {
                "raw": {
                  "padding": "0 16px",
                  "border-radius": "8px",
                  "cursor": "pointer",
                  "display": "inline-flex",
                  "font-family": "Inter",
                  "font-size": "13px",
                  "font-weight": "600",
                  "background": "linear-gradient(rgb(121,88,242),rgb(128,38,255))",
                  "color": "rgb(249,249,249)",
                  "border": "0"
                }
              },
              "layout": {
                "height": {
                  "mode": "px",
                  "value": 38
                },
                "align": "center",
                "justify": "center",
                "gapRem": 0.5,
                "width": {
                  "mode": "percent",
                  "value": 100
                }
              },
              "children": [
                {
                  "id": "icon-use-as-base-mobile",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "14",
                    "height": "14",
                    "viewBox": "0 0 16 16"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "icon-use-as-base-mobile-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M4 8h8m-3-3l3 3-3 3",
                        "stroke": "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "auto"
                    }
                  ],
                  "layoutMode": "auto"
                },
                {
                  "id": "btn-use-as-base-mobile-label",
                  "tag": "span",
                  "text": "Use as base",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "layoutMode": "auto"
                }
              ],
              "triggers": [
                {
                  "on": "click",
                  "action": "emit",
                  "target": "useAsBase",
                  "payload": {
                    "prompt": "{{props.prompt}}",
                    "negative": "{{props.negative}}",
                    "model": "{{props.model}}",
                    "seed": "{{props.seed}}",
                    "cfgScale": "{{props.cfgScale}}",
                    "steps": "{{props.steps}}",
                    "sampler": "{{props.sampler}}",
                    "scheduler": "{{props.scheduler}}",
                    "aspect": "{{props.aspect}}"
                  }
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "btn-details-mobile",
              "tag": "button",
              "type": "frame",
              "text": "Details",
              "attrs": {
                "type": "button"
              },
              "style": {
                "raw": {
                  "padding": "0 16px",
                  "border-radius": "8px",
                  "cursor": "pointer",
                  "display": "inline-flex",
                  "font-family": "Inter",
                  "font-size": "13px",
                  "font-weight": "600",
                  "background": "transparent",
                  "color": "rgb(180,182,190)",
                  "border": "1px solid rgb(69,69,69)"
                }
              },
              "layout": {
                "height": {
                  "mode": "px",
                  "value": 38
                },
                "align": "center",
                "justify": "center",
                "gapRem": 0.5,
                "width": {
                  "mode": "auto"
                }
              },
              "children": [],
              "triggers": [
                {
                  "on": "click",
                  "value": true,
                  "action": "set",
                  "target": "$_imgDetailsOpen"
                }
              ],
              "layoutMode": "flow"
            }
          ],
          "layoutMode": "flow"
        },
        {
          "id": "details-sheet-mobile",
          "tag": "div",
          "type": "frame",
          "visibleWhen": "{{ $_imgDetailsOpen }}",
          "style": {
            "raw": {
              "position": "fixed",
              "inset": "0"
            }
          },
          "layout": {
            "zIndex": 1200,
            "align": "end"
          },
          "children": [
            {
              "id": "details-sheet-backdrop",
              "tag": "div",
              "type": "frame",
              "style": {
                "raw": {
                  "inset": "0",
                  "background": "rgba(0,0,0,0.5)"
                }
              },
              "layout": {
                "position": "absolute"
              },
              "children": [],
              "triggers": [
                {
                  "on": "click",
                  "value": false,
                  "action": "set",
                  "target": "$_imgDetailsOpen"
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "details-sheet-panel",
              "ref": "ImageMetaSheet",
              "type": "frame",
              "props": {
                "prompt": "{{props.prompt}}",
                "negative": "{{props.negative}}",
                "model": "{{props.model}}",
                "style": "{{props.style}}",
                "aspect": "{{props.aspect}}",
                "cfgScale": "{{props.cfgScale}}",
                "steps": "{{props.steps}}",
                "seed": "{{props.seed}}",
                "sampler": "{{props.sampler}}",
                "scheduler": "{{props.scheduler}}"
              },
              "on": {
                "close": {
                  "action": "emit",
                  "target": "close"
                }
              },
              "layout": {},
              "children": [],
              "layoutMode": "flow",
              "tag": "div"
            }
          ],
          "layoutMode": "flow"
        },
        {
          "id": "confirm-delete-section",
          "tag": "div",
          "type": "frame",
          "style": {
            "raw": {
              "inset": "0"
            }
          },
          "layout": {
            "zIndex": 100,
            "position": "absolute"
          },
          "children": [
            {
              "id": "confirm-delete-backdrop",
              "tag": "div",
              "type": "frame",
              "style": {
                "raw": {
                  "inset": "0",
                  "cursor": "pointer",
                  "background": "rgba(0,0,0,0.55)",
                  "backdrop-filter": "blur(2px)"
                }
              },
              "layout": {
                "position": "absolute"
              },
              "children": [],
              "triggers": [
                {
                  "on": "click",
                  "value": false,
                  "action": "set",
                  "target": "$_confirmDeleteOpen"
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "confirm-delete-wrapper",
              "tag": "div",
              "type": "frame",
              "style": {
                "raw": {
                  "inset": "0",
                  "pointer-events": "none"
                }
              },
              "layout": {
                "align": "center",
                "justify": "center",
                "padding": {
                  "mode": "px",
                  "value": 16
                },
                "position": "absolute"
              },
              "children": [
                {
                  "id": "confirm-delete-instance",
                  "on": {
                    "cancel": {
                      "value": false,
                      "action": "set",
                      "target": "$_confirmDeleteOpen"
                    },
                    "confirm": [
                      {
                        "action": "set",
                        "target": "$_pendingDeleteImageUrl",
                        "value": "{{ $_confirmDeleteTarget }}"
                      },
                      {
                        "action": "sendEvent",
                        "target": "delete-gallery-image",
                        "payload": {
                          "deleteImageUrl": "{{ $_confirmDeleteTarget }}"
                        }
                      },
                      {
                        "value": "{{ globals.generatedImages.filter((img) => img.imageUrl !== globals._confirmDeleteTarget) }}",
                        "action": "set",
                        "target": "$generatedImages"
                      },
                      {
                        "value": "",
                        "action": "set",
                        "target": "$_selectedImageUrl",
                        "condition": "$_selectedImageUrl === $_confirmDeleteTarget"
                      },
                      {
                        "value": false,
                        "action": "set",
                        "target": "$_confirmDeleteOpen"
                      },
                      {
                        "action": "emit",
                        "target": "close"
                      }
                    ]
                  },
                  "ref": "IgConfirmDeleteModal",
                  "type": "frame",
                  "props": {
                    "title": "Delete image?",
                    "message": "This image will be permanently removed from your gallery. This action cannot be undone.",
                    "cancelLabel": "Cancel",
                    "confirmLabel": "Delete"
                  },
                  "style": {
                    "raw": {
                      "pointer-events": "auto"
                    }
                  },
                  "children": [],
                  "layoutMode": "flow",
                  "tag": "div"
                }
              ],
              "layoutMode": "flow"
            }
          ],
          "layoutMode": "flow",
          "visibleWhen": "$_confirmDeleteOpen"
        }
      ],
      "cssClasses": ["image-modal"],
      "layoutMode": "flow"
    },
    "GalleryCard": {
      "id": "GalleryCard",
      "tag": "div",
      "type": "frame",
      "emits": ["select"],
      "attrs": {
        "data-deleting": "{{ (props.item.imageUrl === globals._pendingDeleteImageUrl || props.item.url === globals._pendingDeleteImageUrl || props.item.image === globals._pendingDeleteImageUrl) ? '1' : '' }}"
      },
      "props": {
        "item": {
          "type": "object",
          "default": {
            "id": "img_8f3a2c",
            "image": "https://api.dicebear.com/9.x/adventurer-neutral/svg?seed=Kenzo",
            "model": "SDXL 1.0",
            "ratio": "3:4",
            "prompt": "Cyberpunk samurai standing in neon-lit Tokyo alley, rain reflections, cinematic lighting"
          }
        },
        "nsfw": {
          "type": "boolean",
          "default": false
        }
      },
      "state": {
        "dateLabel": ""
      },
      "script": "function setup(component){function fmt(ts){if(ts==null||ts==='')return '';var n=Number(ts);if(!Number.isFinite(n)||n<=0)return String(ts);var d=new Date(n);if(isNaN(d.getTime()))return String(ts);var p=function(x){return String(x).padStart(2,'0');};return p(d.getDate())+'.'+p(d.getMonth()+1)+'.'+d.getFullYear()+' '+p(d.getHours())+':'+p(d.getMinutes());}function apply(){var item=component.props.item||{};var l=fmt(item.timestamp);if(component.state.dateLabel!==l)component.state.dateLabel=l;}apply();component.watch(function(){var item=component.props.item||{};return item.timestamp;},apply);}",
      "style": {
        "raw": {
          "cursor": "pointer",
          "background": "rgb(50,50,50)",
          "transition": "transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease"
        },
        "hover": {
          "raw": {
            "transform": "translateY(-2px)",
            "box-shadow": "0 6px 18px rgba(0,0,0,0.35)"
          },
          "borderColor": "rgb(226,137,255)"
        },
        "active": {
          "raw": {
            "transform": "translateY(0)"
          }
        },
        "radius": {
          "mode": "px",
          "value": 12
        },
        "textAlign": "left",
        "borderColor": "rgb(69,69,69)",
        "borderStyle": "solid",
        "borderWidthPx": 1
      },
      "layout": {
        "padding": {
          "mode": "px",
          "value": 0
        },
        "direction": "column"
      },
      "children": [
        {
          "id": "g-f18-f1ebfb",
          "tag": "div",
          "type": "frame",
          "style": {
            "raw": {
              "background": "url({{props.item.image || props.item.url || props.item.imageUrl}}) center center/cover, rgb(63,63,63)",
              "aspect-ratio": "3/4"
            }
          },
          "layout": {
            "position": "relative"
          },
          "children": [
            {
              "id": "g-shimmer",
              "tag": "div",
              "type": "frame",
              "visibleWhen": "props.item.imageUrl === globals._pendingDeleteImageUrl || props.item.url === globals._pendingDeleteImageUrl || props.item.image === globals._pendingDeleteImageUrl",
              "cssClasses": ["card-shimmer"],
              "style": {
                "raw": {
                  "inset": "0",
                  "border-radius": "12px"
                }
              },
              "layout": {
                "position": "absolute",
                "zIndex": 5
              },
              "children": [],
              "layoutMode": "flow"
            },
            {
              "id": "g-f19-433f45",
              "tag": "span",
              "text": "NSFW",
              "type": "frame",
              "style": {
                "raw": {
                  "background": "rgba(251,75,87,0.85)"
                },
                "radius": {
                  "mode": "px",
                  "value": 4
                },
                "fontSize": {
                  "mode": "px",
                  "value": 10
                },
                "textColor": "rgb(255,255,255)",
                "fontFamily": "Inter,sans-serif",
                "fontWeight": 700,
                "letterSpacing": {
                  "mode": "px",
                  "value": 0.4
                }
              },
              "layout": {
                "topPx": 8,
                "leftPx": 8,
                "padding": [
                  {
                    "mode": "px",
                    "value": 2
                  },
                  {
                    "mode": "px",
                    "value": 6
                  }
                ],
                "position": "absolute"
              },
              "children": [],
              "cssClasses": ["card__nsfw"],
              "layoutMode": "auto",
              "visibleWhen": "props.nsfw"
            }
          ],
          "cssClasses": ["card__image"],
          "layoutMode": "auto"
        },
        {
          "id": "g-f20-b7ea13",
          "tag": "div",
          "type": "frame",
          "layout": {
            "gap": {
              "mode": "px",
              "value": 4
            },
            "padding": [
              {
                "mode": "px",
                "value": 10
              },
              {
                "mode": "px",
                "value": 12
              }
            ],
            "direction": "column"
          },
          "children": [
            {
              "id": "g-f21-ba3741",
              "tag": "span",
              "text": "{{props.item.prompt}}",
              "type": "frame",
              "style": {
                "raw": {
                  "display": "-webkit-box",
                  "-webkit-box-orient": "vertical",
                  "-webkit-line-clamp": "2"
                },
                "fontSize": {
                  "mode": "px",
                  "value": 12
                },
                "textColor": "rgb(249,249,249)",
                "fontFamily": "Inter,sans-serif",
                "lineHeight": {
                  "mode": "px",
                  "value": 16
                }
              },
              "layout": {},
              "children": [],
              "overflow": "hidden",
              "cssClasses": ["card__prompt"],
              "layoutMode": "auto"
            },
            {
              "id": "g-f22-9e1d45",
              "tag": "span",
              "text": "{{props.item.model}} · {{props.item.ratio || props.item.resolution}} · {{state.dateLabel}}",
              "type": "frame",
              "style": {
                "fontSize": {
                  "mode": "px",
                  "value": 11
                },
                "textColor": "rgb(135,138,146)",
                "fontFamily": "Inter,sans-serif"
              },
              "layout": {},
              "children": [],
              "cssClasses": ["card__meta"],
              "layoutMode": "auto"
            }
          ],
          "cssClasses": ["card__body"],
          "layoutMode": "flow"
        }
      ],
      "overflow": "hidden",
      "triggers": [
        {
          "on": "click",
          "value": {
            "kind": "ref",
            "path": ["item"],
            "root": "props"
          },
          "action": "emit",
          "target": "select",
          "condition": "props.item.imageUrl !== globals._pendingDeleteImageUrl && props.item.url !== globals._pendingDeleteImageUrl && props.item.image !== globals._pendingDeleteImageUrl"
        }
      ],
      "cssClasses": ["card"],
      "layoutMode": "flow"
    },
    "IgRangeSlider": {
      "id": "InputRange",
      "css": "[__sc__]::-webkit-scrollbar{width:8px;height:8px}\n[__sc__]::-webkit-scrollbar-thumb{background:rgb(69,69,69);border-radius:999px}\n[__sc__]::-webkit-scrollbar-track{background:transparent}\ninput[type=\"range\"][__sc__]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:14px;height:14px;border-radius:999px;background:#fff;border:2px solid rgb(121,88,242);cursor:pointer;transition:border-color 0.15s,background 0.15s}\ninput[type=\"range\"][__sc__]::-moz-range-thumb{width:14px;height:14px;border-radius:999px;background:#fff;border:2px solid rgb(121,88,242);cursor:pointer;transition:border-color 0.15s,background 0.15s}\ninput[type=\"range\"][__sc__]:disabled{cursor:not-allowed}\ninput[type=\"range\"][__sc__]:disabled::-webkit-slider-thumb{background:rgb(180,182,190);border-color:rgb(90,90,90);cursor:not-allowed}\ninput[type=\"range\"][__sc__]:disabled::-moz-range-thumb{background:rgb(180,182,190);border-color:rgb(90,90,90);cursor:not-allowed}",
      "tag": "div",
      "name": "InputRange",
      "type": "frame",
      "emits": ["change"],
      "props": {
        "max": {
          "type": "number",
          "default": 100
        },
        "min": {
          "type": "number",
          "default": 0
        },
        "step": {
          "type": "number",
          "default": 1
        },
        "value": {
          "type": "number",
          "default": 0
        },
        "disabled": {
          "type": "boolean",
          "default": false
        }
      },
      "style": {
        "when": [
          {
            "expr": {
              "kind": "ref",
              "path": ["disabled"],
              "root": "props"
            },
            "apply": {
              "raw": {
                "cursor": "not-allowed",
                "opacity": "0.55"
              }
            }
          }
        ]
      },
      "layout": {
        "gap": {
          "mode": "px",
          "value": 10
        },
        "align": "center"
      },
      "children": [
        {
          "id": "f2",
          "tag": "input",
          "type": "frame",
          "attrs": {
            "max": "{{props.max}}",
            "min": "{{props.min}}",
            "step": "{{props.step}}",
            "type": "range",
            "value": "{{props.value}}",
            "disabled": "{{props.disabled}}"
          },
          "style": {
            "raw": {
              "flex": "1 1 0%",
              "cursor": "pointer",
              "outline": "none",
              "appearance": "none"
            },
            "when": [
              {
                "expr": {
                  "kind": "ref",
                  "path": ["disabled"],
                  "root": "props"
                },
                "apply": {
                  "raw": {
                    "cursor": "not-allowed",
                    "filter": "grayscale(1)"
                  }
                }
              }
            ],
            "radius": {
              "mode": "px",
              "value": 999
            }
          },
          "layout": {
            "height": {
              "mode": "px",
              "value": 4
            }
          },
          "children": [],
          "triggers": [
            {
              "on": "input",
              "chain": [
                {
                  "action": "readValue",
                  "target": "#_rangeValue",
                  "readFrom": "valueAsNumber"
                },
                {
                  "action": "emit",
                  "target": "change",
                  "payload": {
                    "value": "{{state._rangeValue}}"
                  }
                }
              ],
              "condition": "!props.disabled"
            }
          ],
          "cssClasses": ["range"],
          "layoutMode": "auto",
          "inlineStyleWhen": [
            {
              "expr": "'linear-gradient(to right,rgb(121,88,242) 0%,rgb(128,38,255) ' + ((max(props.min, min(props.max, props.value)) - props.min) / (props.max - props.min) * 100) + '%,rgb(69,69,69) ' + ((max(props.min, min(props.max, props.value)) - props.min) / (props.max - props.min) * 100) + '%,rgb(69,69,69) 100%)'",
              "prop": "background"
            }
          ]
        },
        {
          "id": "f3",
          "tag": "span",
          "text": "{{props.value}}",
          "type": "frame",
          "style": {
            "raw": {
              "background": "rgb(50,50,50)"
            },
            "when": [
              {
                "expr": {
                  "kind": "ref",
                  "path": ["disabled"],
                  "root": "props"
                },
                "apply": {
                  "raw": {
                    "background": "rgb(40,40,40)"
                  },
                  "textColor": "rgb(120,120,120)",
                  "borderColor": "rgb(58,58,58)"
                }
              }
            ],
            "radius": {
              "mode": "px",
              "value": 6
            },
            "fontSize": {
              "mode": "px",
              "value": 11
            },
            "textColor": "rgb(249,249,249)",
            "fontWeight": 600,
            "borderColor": "rgb(69,69,69)",
            "borderStyle": "solid",
            "borderWidthPx": 1
          },
          "layout": {
            "align": "center",
            "height": {
              "mode": "px",
              "value": 24
            },
            "justify": "center",
            "padding": [
              {
                "mode": "px",
                "value": 0
              },
              {
                "mode": "px",
                "value": 8
              }
            ],
            "minWidth": {
              "mode": "px",
              "value": 44
            }
          },
          "children": [],
          "cssClasses": ["range-value"],
          "layoutMode": "flow"
        }
      ],
      "cssClasses": ["range-container"],
      "layoutMode": "flow"
    },
    "UiButtonLib": {
      "id": "fbaff870",
      "tag": "button",
      "name": "UiButtonLib",
      "type": "frame",
      "attrs": {
        "type": "{{ props.type }}",
        "disabled": "{{ props.disabled || props.loading }}",
        "aria-busy": "{{ props.loading }}",
        "aria-label": "{{ props.ariaLabel ? props.ariaLabel : null }}",
        "aria-disabled": "{{ props.disabled }}"
      },
      "emits": ["buttonClick"],
      "props": {
        "size": {
          "type": "enum",
          "values": ["small", "m", "big", "l", "xl", "xxl"],
          "default": "m"
        },
        "text": {
          "type": "string",
          "default": ""
        },
        "type": {
          "type": "enum",
          "values": ["button", "submit", "reset"],
          "default": "submit"
        },
        "active": {
          "type": "boolean",
          "default": false
        },
        "loading": {
          "type": "boolean",
          "default": false
        },
        "rounded": {
          "type": "boolean",
          "default": false
        },
        "variant": {
          "type": "enum",
          "values": ["primary", "accent", "secondary", "outline", "ghost"],
          "default": "primary"
        },
        "disabled": {
          "type": "boolean",
          "default": false
        },
        "iconOnly": {
          "type": "boolean",
          "default": false
        },
        "ariaLabel": {
          "type": "string",
          "default": ""
        }
      },
      "style": {
        "raw": {
          "cursor": "pointer",
          "box-sizing": "border-box",
          "transition": "all 300ms",
          "user-select": "none",
          "background-size": "200% auto"
        },
        "hover": {
          "raw": {
            "background-position": "35% center"
          }
        },
        "modifiers": [
          {
            "expr": "props.variant === 'primary'",
            "apply": {
              "hover": {
                "gradient": "linear-gradient(121deg, #8666F8 18.1%, #8D3DFE 90.98%)",
                "textColor": "#F9F9F9"
              },
              "active": {
                "gradient": "linear-gradient(121deg, #6548CC 18.1%, #6548CC 90.98%)",
                "textColor": "#F9F9F9"
              },
              "disabled": {
                "gradient": "linear-gradient(121deg, #454545 18.1%, #454545 90.98%)",
                "textColor": "#696A6D"
              },
              "gradient": "linear-gradient(121deg, #7958F2 18.1%, #8026FF 90.98%)",
              "textColor": "#F9F9F9"
            }
          },
          {
            "expr": "props.variant === 'accent'",
            "apply": {
              "hover": {
                "gradient": "linear-gradient(145deg, #F372FF 0%, #FFD153 50%)",
                "textColor": "#0C0C0C"
              },
              "active": {
                "gradient": "linear-gradient(145deg, #F372FF 0%, #FFD153 50%)",
                "textColor": "#0C0C0C"
              },
              "disabled": {
                "gradient": "#323232",
                "textColor": "#696A6D"
              },
              "gradient": "linear-gradient(145deg, #F372FF 0%, #FFD153 50%)",
              "textColor": "#0C0C0C"
            }
          },
          {
            "expr": "props.variant === 'secondary'",
            "apply": {
              "hover": {
                "gradient": "#545456",
                "textColor": "#F9F9F9"
              },
              "active": {
                "gradient": "#323232",
                "textColor": "#F9F9F9"
              },
              "disabled": {
                "gradient": "#454545",
                "textColor": "#696A6D"
              },
              "gradient": "#454545",
              "textColor": "#F9F9F9"
            }
          },
          {
            "expr": "props.variant === 'outline'",
            "apply": {
              "hover": {
                "gradient": "transparent",
                "textColor": "#B4B6BE",
                "borderColor": "#828389",
                "borderStyle": "solid"
              },
              "active": {
                "gradient": "transparent",
                "textColor": "#828389",
                "borderColor": "#545456",
                "borderStyle": "solid"
              },
              "disabled": {
                "gradient": "transparent",
                "textColor": "#696A6D"
              },
              "gradient": "transparent",
              "textColor": "#EBEBEB",
              "borderColor": "rgb(69,69,69)",
              "borderStyle": "solid",
              "borderWidthPx": 1
            }
          },
          {
            "expr": "props.variant === 'ghost'",
            "apply": {
              "hover": {
                "gradient": "transparent",
                "textColor": "rgb(226,137,255)"
              },
              "active": {
                "gradient": "transparent",
                "textColor": "#545456"
              },
              "disabled": {
                "opacity": 1,
                "gradient": "transparent",
                "textColor": "#828389"
              },
              "gradient": "transparent",
              "textColor": "#EBEBEB"
            }
          },
          {
            "expr": "props.size === 'small'",
            "apply": {
              "height": {
                "mode": "px",
                "value": 16
              },
              "paddingRem": [0, 0.5, 0, 0.5],
              "fontSize": {
                "mode": "px",
                "value": 12
              },
              "lineHeight": {
                "mode": "px",
                "value": 16
              }
            }
          },
          {
            "expr": "props.size === 'big'",
            "apply": {
              "height": {
                "mode": "px",
                "value": 32
              },
              "paddingRem": [0.5, 1, 0.5, 1],
              "fontSize": {
                "mode": "px",
                "value": 14
              },
              "lineHeight": {
                "mode": "px",
                "value": 20
              }
            }
          },
          {
            "expr": "props.size === 'l'",
            "apply": {
              "height": {
                "mode": "px",
                "value": 38
              },
              "paddingRem": [0.5, 1, 0.5, 1],
              "fontSize": {
                "mode": "px",
                "value": 14
              },
              "lineHeight": {
                "mode": "px",
                "value": 20
              }
            }
          },
          {
            "expr": "props.size === 'xl'",
            "apply": {
              "height": {
                "mode": "px",
                "value": 44
              },
              "paddingRem": [0.625, 1, 0.625, 1],
              "fontSize": {
                "mode": "px",
                "value": 16
              },
              "lineHeight": {
                "mode": "px",
                "value": 24
              }
            }
          },
          {
            "expr": "props.size === 'xxl'",
            "apply": {
              "height": {
                "mode": "px",
                "value": 56
              },
              "paddingRem": [1, 1.25, 1, 1.25],
              "fontSize": {
                "mode": "px",
                "value": 16
              },
              "lineHeight": {
                "mode": "px",
                "value": 24
              }
            }
          },
          {
            "expr": "props.disabled",
            "apply": {
              "raw": {
                "cursor": "not-allowed"
              }
            }
          },
          {
            "expr": "props.loading",
            "apply": {
              "raw": {
                "cursor": "wait"
              }
            }
          },
          {
            "expr": "props.active && props.variant === 'primary'",
            "apply": {
              "gradient": "linear-gradient(121deg, #6548CC 18.1%, #6548CC 90.98%)",
              "textColor": "#F9F9F9"
            }
          },
          {
            "expr": "props.active && props.variant === 'accent'",
            "apply": {
              "gradient": "linear-gradient(145deg, #F372FF 0%, #FFD153 50%)",
              "textColor": "#0C0C0C"
            }
          },
          {
            "expr": "props.active && props.variant === 'secondary'",
            "apply": {
              "gradient": "#323232",
              "textColor": "#F9F9F9"
            }
          },
          {
            "expr": "props.active && props.variant === 'outline'",
            "apply": {
              "gradient": "transparent",
              "textColor": "#828389",
              "borderColor": "#545456"
            }
          },
          {
            "expr": "props.active && props.variant === 'ghost'",
            "apply": {
              "gradient": "transparent",
              "textColor": "#545456"
            }
          },
          {
            "expr": "props.iconOnly",
            "apply": {
              "raw": {
                "flex-shrink": "0",
                "aspect-ratio": "1"
              },
              "paddingRem": [0, 0, 0, 0]
            }
          },
          {
            "expr": "props.rounded",
            "apply": {
              "radiusRem": 9999
            }
          },
          {
            "expr": ":disabled",
            "apply": {
              "opacity": 0.5
            }
          }
        ],
        "radiusRem": 0.5,
        "fontSize": {
          "mode": "px",
          "value": 14
        },
        "lineHeight": {
          "mode": "px",
          "value": 20
        }
      },
      "layout": {
        "align": "center",
        "height": {
          "mode": "px",
          "value": 24
        },
        "justify": "center",
        "position": "relative",
        "direction": "row",
        "paddingRem": [0.25, 0.5, 0.25, 0.5]
      },
      "__source": "uibutton-root",
      "children": [
        {
          "id": "70608060",
          "tag": "div",
          "type": "frame",
          "style": {
            "when": [
              {
                "expr": "props.loading",
                "apply": {
                  "raw": {
                    "visibility": "hidden"
                  }
                }
              }
            ]
          },
          "layout": {
            "align": "center",
            "gapRem": 0.25,
            "justify": "center",
            "direction": "row"
          },
          "children": [
            {
              "id": "2c34b8b9",
              "type": "frame",
              "layout": {},
              "children": [],
              "layoutMode": "flow",
              "componentSlot": {
                "max": 1,
                "name": "iconLeft",
                "allowedRefs": ["uiSvg", "uiImage"]
              },
              "tag": "div"
            },
            {
              "id": "930d4316",
              "tag": "div",
              "type": "frame",
              "style": {
                "raw": {
                  "white-space": "nowrap",
                  "text-overflow": "ellipsis"
                },
                "when": [
                  {
                    "expr": "props.iconOnly",
                    "apply": {
                      "raw": {
                        "display": "flex",
                        "align-items": "center",
                        "pointer-events": "none",
                        "justify-content": "center"
                      }
                    }
                  }
                ]
              },
              "layout": {},
              "children": [
                {
                  "id": "f2ef3f71",
                  "tag": "span",
                  "text": "{{ props.text }}",
                  "type": "frame",
                  "layout": {},
                  "children": [],
                  "layoutMode": "flow"
                }
              ],
              "layoutMode": "flow",
              "overflow": "hidden"
            },
            {
              "id": "a55ef289",
              "type": "frame",
              "layout": {},
              "children": [],
              "layoutMode": "flow",
              "componentSlot": {
                "max": 1,
                "name": "iconRight",
                "allowedRefs": ["uiSvg", "uiImage"]
              },
              "tag": "div"
            }
          ],
          "layoutMode": "flow"
        },
        {
          "id": "25f4c952",
          "css": "\n        @keyframes ui-button-spinner-rotate {\n          from { transform: translate(-50%, -50%) rotate(0deg); }\n          to   { transform: translate(-50%, -50%) rotate(360deg); }\n        }\n        [__sc__] .ui-button-spinner {\n          animation: ui-button-spinner-rotate 0.8s linear infinite;\n        }\n      ",
          "tag": "div",
          "type": "frame",
          "style": {
            "raw": {
              "transform": "translate(-50%, -50%)"
            },
            "textColor": "currentColor"
          },
          "layout": {
            "width": {
              "mode": "rem",
              "value": 1.5
            },
            "height": {
              "mode": "px",
              "value": 24
            },
            "position": "absolute",
            "topPercent": 50,
            "leftPercent": 50
          },
          "children": [
            {
              "id": "a695da53",
              "tag": "svg",
              "type": "frame",
              "attrs": {
                "fill": "none",
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 24 24"
              },
              "layout": {},
              "children": [
                {
                  "id": "3438826b",
                  "tag": "circle",
                  "type": "frame",
                  "attrs": {
                    "r": "10",
                    "cx": "12",
                    "cy": "12",
                    "stroke": "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-dasharray": "47 16"
                  },
                  "layout": {},
                  "children": [],
                  "layoutMode": "flow"
                }
              ],
              "layoutMode": "flow"
            }
          ],
          "cssClasses": ["ui-button-spinner"],
          "layoutMode": "flow",
          "visibleWhen": "props.loading"
        }
      ],
      "triggers": [
        {
          "on": "click",
          "action": "emit",
          "target": "buttonClick"
        }
      ],
      "layoutMode": "flow"
    },
    "IgButtonPrimary": {
      "id": "ButtonPrimary",
      "tag": "button",
      "type": "frame",
      "attrs": {
        "disabled": "{{props.disabled}}"
      },
      "emits": ["submit"],
      "props": {
        "text": {
          "type": "string",
          "default": "Submit"
        },
        "disabled": {
          "type": "boolean",
          "default": false
        }
      },
      "state": {
        "var0": false
      },
      "style": {
        "raw": {
          "cursor": "pointer",
          "background": "linear-gradient(121deg, #7958F2 18.1%, #8026FF 90.98%)",
          "transition": "transform 0.08s,filter 0.15s,border-color 0.15s,background 0.15s,color 0.15s"
        },
        "hover": {
          "raw": {
            "background": "linear-gradient(121deg, #8666F8 18.1%, #8D3DFE 90.98%)"
          }
        },
        "active": {
          "raw": {
            "background": "linear-gradient(121deg, #6548CC 18.1%, #6548CC 90.98%)",
            "transform": "translateY(1px)"
          }
        },
        "radius": {
          "mode": "px",
          "value": 8
        },
        "fontSize": {
          "mode": "px",
          "value": 14
        },
        "modifiers": [
          {
            "expr": "props.disabled",
            "apply": {
              "raw": {
                "cursor": "not-allowed"
              }
            }
          },
          {
            "expr": ":disabled",
            "apply": {
              "opacity": 0.5
            }
          }
        ],
        "textColor": "rgb(249,249,249)",
        "fontFamily": "Inter,sans-serif",
        "fontWeight": 600,
        "borderColor": "transparent",
        "borderStyle": "solid",
        "borderWidthPx": 1
      },
      "layout": {
        "gap": {
          "mode": "px",
          "value": 8
        },
        "align": "center",
        "width": {
          "mode": "fill"
        },
        "height": {
          "mode": "px",
          "value": 44
        },
        "justify": "center",
        "padding": [
          {
            "mode": "px",
            "value": 0
          },
          {
            "mode": "px",
            "value": 20
          }
        ]
      },
      "children": [
        {
          "id": "f103",
          "tag": "svg",
          "type": "frame",
          "attrs": {
            "fill": "none",
            "width": "16",
            "height": "16",
            "viewBox": "0 0 16 16"
          },
          "layout": {},
          "children": [
            {
              "id": "f104",
              "tag": "path",
              "type": "frame",
              "attrs": {
                "d": "M8 1l1.6 4.8L14 7.5l-4.4 1.7L8 14l-1.6-4.8L2 7.5l4.4-1.7L8 1z",
                "fill": "currentColor"
              },
              "layout": {},
              "children": [],
              "layoutMode": "auto"
            }
          ],
          "layoutMode": "auto"
        },
        {
          "id": "f105",
          "text": "{{props.text}}",
          "type": "frame",
          "layout": {},
          "children": [],
          "layoutMode": "auto",
          "tag": "div"
        }
      ],
      "triggers": [
        {
          "id": "hyrbox4i4so",
          "on": "click",
          "action": "emit",
          "target": "submit",
          "condition": "!props.disabled"
        },
        {
          "id": "0nx0r3mluddi",
          "on": "click",
          "action": "toggle",
          "target": "#"
        }
      ],
      "cssClasses": ["ig-btn", "ig-btn--primary", "ig-btn--lg", "ig-btn--block"],
      "layoutMode": "flow"
    },
    "UiSelect Model": {
      "id": "79de5525",
      "on": {
        "tag:remove": {
          "chain": [
            {
              "value": null,
              "action": "set",
              "target": "props.value",
              "condition": "{{ props.value.length === 0 }}"
            }
          ],
          "value": "{{ emit }}",
          "action": "removeState",
          "target": "props.value"
        },
        "option:click": {
          "chain": [
            {
              "value": "{{ emit }}",
              "action": "set",
              "target": "props.value",
              "condition": "{{ !props.multiple }}"
            },
            {
              "value": "{{ props.value && props.value.some(o => o.id === emit.id) ? props.value.filter(o => o.id !== emit.id) : (props.value || []).concat([emit]) }}",
              "action": "set",
              "target": "props.value",
              "condition": "{{ props.multiple }}"
            },
            {
              "value": null,
              "action": "set",
              "target": "props.value",
              "condition": "{{ props.multiple && props.value && props.value.length === 0 }}"
            }
          ],
          "value": "{{ emit }}",
          "action": "set",
          "target": "props.value",
          "condition": "{{ !props.multiple }}"
        }
      },
      "tag": "div",
      "name": "UiSelect Model",
      "type": "frame",
      "emits": ["change", "open", "close"],
      "props": {
        "value": {
          "type": "object",
          "default": null
        },
        "options": {
          "type": "array",
          "default": []
        },
        "disabled": {
          "type": "boolean",
          "default": false
        },
        "multiple": {
          "type": "boolean",
          "default": false
        },
        "required": {
          "type": "boolean",
          "default": false
        },
        "placement": {
          "type": "enum",
          "values": ["bottom-start", "bottom-end", "top-start", "top-end"],
          "default": "bottom-start"
        },
        "searchable": {
          "type": "boolean",
          "default": false
        },
        "hasBackdrop": {
          "type": "boolean",
          "default": false
        },
        "placeholder": {
          "type": "string",
          "default": ""
        },
        "closeOnSelect": {
          "type": "boolean",
          "default": true
        },
        "dropdownWidth": {
          "type": "string",
          "default": "match-trigger"
        },
        "disableTagClick": {
          "type": "boolean",
          "default": false
        },
        "searchInputPlaceholder": {
          "type": "string",
          "default": ""
        }
      },
      "state": {
        "isOpen": false,
        "search": ""
      },
      "style": {
        "raw": {
          "box-sizing": "border-box"
        }
      },
      "layout": {
        "width": {
          "mode": "fill"
        },
        "gapRem": 1,
        "direction": "column"
      },
      "script": "\n    function setup(component) {\n      let _prev = component.state.isOpen === true;\n      component.watch(\n        () => component.state.isOpen,\n        (next) => {\n          const truthy = next === true;\n          if (truthy === _prev) return;\n          _prev = truthy;\n          component.emit(truthy ? 'open' : 'close', {});\n        },\n      );\n    }\n  ",
      "__source": "uiselect-root",
      "children": [
        {
          "id": "uiselect-trigger",
          "tag": "button",
          "type": "frame",
          "attrs": {
            "type": "button",
            "disabled": "{{ props.disabled }}"
          },
          "style": {
            "raw": {
              "cursor": "pointer",
              "transition": "background-color 300ms ease, border-color 300ms ease-in-out",
              "user-select": "none"
            },
            "hover": {
              "backgroundColor": "#454545"
            },
            "disabled": {
              "backgroundColor": "#454545"
            },
            "modifiers": [
              {
                "expr": "state.isOpen",
                "apply": {
                  "borderColor": "rgb(226,137,255)"
                }
              },
              {
                "expr": "props.disabled",
                "apply": {
                  "raw": {
                    "cursor": "not-allowed"
                  }
                }
              }
            ],
            "radiusRem": 0.5,
            "textColor": "#B4B6BE",
            "borderColor": "#454545",
            "borderStyle": "solid",
            "fontSize": {
              "mode": "px",
              "value": 14
            },
            "borderWidthPx": 1,
            "lineHeight": {
              "mode": "px",
              "value": 20
            },
            "backgroundColor": "#323232"
          },
          "layout": {
            "align": "center",
            "width": {
              "mode": "fill"
            },
            "gapRem": 0.5,
            "height": {
              "mode": "px",
              "value": 44
            },
            "justify": "space-between",
            "direction": "row",
            "paddingRem": [0.75, 1, 0.75, 1],
            "minWidthRem": 10
          },
          "children": [
            {
              "id": "uiselect-trigger-content",
              "tag": "div",
              "type": "frame",
              "style": {
                "raw": {
                  "min-width": "0"
                }
              },
              "layout": {
                "align": "center",
                "width": {
                  "mode": "fill"
                },
                "gapRem": 0.5,
                "direction": "row"
              },
              "children": [
                {
                  "id": "uiselect-placeholder",
                  "tag": "span",
                  "text": "{{ props.placeholder }}",
                  "type": "frame",
                  "style": {
                    "textColor": "#B4B6BE",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    },
                    "lineHeight": {
                      "mode": "px",
                      "value": 20
                    }
                  },
                  "layout": {},
                  "children": [],
                  "overflow": "hidden",
                  "layoutMode": "flow",
                  "visibleWhen": "(props.value == null || props.value.length === 0) && !!props.placeholder"
                },
                {
                  "id": "uiselect-single-value",
                  "tag": "div",
                  "type": "frame",
                  "style": {
                    "raw": {
                      "min-width": "0"
                    }
                  },
                  "layout": {
                    "align": "center",
                    "width": {
                      "mode": "fill"
                    },
                    "gapRem": 0.375,
                    "direction": "row"
                  },
                  "children": [
                    {
                      "id": "uiselect-single-label",
                      "tag": "span",
                      "text": "{{ props.value && (props.value.name || props.value.id) }}",
                      "type": "frame",
                      "style": {
                        "textColor": "#F9F9F9",
                        "fontSize": {
                          "mode": "px",
                          "value": 14
                        },
                        "lineHeight": {
                          "mode": "px",
                          "value": 20
                        }
                      },
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "layoutMode": "flow"
                    },
                    {
                      "id": "uiselect-single-badge",
                      "tag": "span",
                      "text": "{{ (props.value && props.value.genres && props.value.genres[0]) }}",
                      "type": "frame",
                      "style": {
                        "raw": {
                          "line-height": "1.25"
                        },
                        "modifiers": [
                          {
                            "expr": "(props.value && props.value.genres && props.value.genres[0] === 'NSFW')",
                            "apply": {
                              "textColor": "rgb(251,75,87)",
                              "backgroundColor": "rgba(251,75,87,0.16)"
                            }
                          }
                        ],
                        "radiusRem": 0.25,
                        "textColor": "rgb(103,255,121)",
                        "fontWeight": 700,
                        "fontSize": {
                          "mode": "px",
                          "value": 9.5
                        },
                        "backgroundColor": "rgba(103,255,121,0.12)"
                      },
                      "layout": {
                        "flexShrink": 0,
                        "paddingRem": [0.0625, 0.3125, 0.0625, 0.3125]
                      },
                      "children": [],
                      "layoutMode": "flow",
                      "visibleWhen": "props.value && !!(props.value.genres && props.value.genres[0])"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!props.multiple && props.value != null"
                },
                {
                  "id": "uiselect-tag-container",
                  "tag": "div",
                  "type": "frame",
                  "layout": {
                    "wrap": "wrap",
                    "width": {
                      "mode": "fill"
                    },
                    "gapRem": 0.5,
                    "direction": "row"
                  },
                  "children": [
                    {
                      "id": "uiselect-tag-template",
                      "tag": "div",
                      "type": "frame",
                      "emits": ["tag:remove"],
                      "style": {
                        "raw": {
                          "cursor": "pointer",
                          "user-select": "none"
                        },
                        "hover": {
                          "backgroundColor": "#323232"
                        },
                        "radiusRem": 0.5,
                        "textColor": "#F9F9F9",
                        "fontWeight": 400,
                        "fontSize": {
                          "mode": "px",
                          "value": 14
                        },
                        "borderWidthPx": 0,
                        "lineHeight": {
                          "mode": "px",
                          "value": 20
                        },
                        "backgroundColor": "#2B2B2B"
                      },
                      "layout": {
                        "align": "center",
                        "gapRem": 0.5,
                        "justify": "space-between",
                        "direction": "row",
                        "paddingRem": [0.25, 0.5, 0.25, 0.5],
                        "minWidthRem": 2.5,
                        "minHeightRem": 2
                      },
                      "repeat": {
                        "as": "tag",
                        "key": "value",
                        "over": "props.value",
                        "idTemplate": "uiselect-tag-{i}"
                      },
                      "children": [
                        {
                          "id": "uiselect-tag-label",
                          "tag": "span",
                          "text": "{{ tag.name || tag.id }}",
                          "type": "frame",
                          "style": {},
                          "layout": {},
                          "children": [],
                          "overflow": "hidden",
                          "layoutMode": "flow"
                        },
                        {
                          "id": "uiselect-tag-close",
                          "tag": "span",
                          "text": "✕",
                          "type": "frame",
                          "style": {
                            "raw": {
                              "user-select": "none"
                            },
                            "textColor": "#F9F9F9",
                            "fontSize": {
                              "mode": "px",
                              "value": 14
                            }
                          },
                          "layout": {},
                          "children": [],
                          "layoutMode": "flow"
                        }
                      ],
                      "triggers": [
                        {
                          "on": "click",
                          "action": "emit",
                          "target": "tag:remove",
                          "payload": {
                            "label": "{{tag.name}}",
                            "value": "{{tag.id}}"
                          }
                        }
                      ],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "props.multiple && props.value && props.value.length > 0"
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "uiselect-caret-down",
              "tag": "span",
              "type": "frame",
              "style": {
                "raw": {
                  "color": "rgb(135, 138, 146)"
                }
              },
              "layout": {
                "flexShrink": 0
              },
              "children": [
                {
                  "id": "uiselect-caret-down-icon",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "12",
                    "height": "12",
                    "viewBox": "0 0 12 12"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "uiselect-caret-down-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M3 4.5l3 3 3-3",
                        "stroke": "currentColor",
                        "stroke-width": "1.4",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow"
                }
              ],
              "layoutMode": "flow",
              "visibleWhen": "!state.isOpen"
            },
            {
              "id": "uiselect-caret-up",
              "tag": "span",
              "type": "frame",
              "style": {
                "raw": {
                  "color": "rgb(135, 138, 146)",
                  "transform": "rotate(180deg)"
                }
              },
              "layout": {
                "flexShrink": 0
              },
              "children": [
                {
                  "id": "uiselect-caret-up-icon",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "12",
                    "height": "12",
                    "viewBox": "0 0 12 12"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "uiselect-caret-up-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M3 4.5l3 3 3-3",
                        "stroke": "currentColor",
                        "stroke-width": "1.4",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow"
                }
              ],
              "layoutMode": "flow",
              "visibleWhen": "state.isOpen"
            }
          ],
          "triggers": [
            {
              "on": "click",
              "action": "toggle",
              "target": "#isOpen",
              "condition": "!props.disabled && !props.disableTagClick"
            }
          ],
          "layoutMode": "flow"
        },
        {
          "id": "uiselect-dropdown",
          "tag": "div",
          "type": "overlay",
          "style": {
            "raw": {
              "width": "{{ props.dropdownWidth === \"fit-content\" ? \"max-content !important\" : (props.dropdownWidth === \"match-trigger\" || !props.dropdownWidth ? \"\" : props.dropdownWidth + \" !important\") }}",
              "overflow-y": "auto"
            },
            "radiusRem": 0.75,
            "backgroundColor": "#454545"
          },
          "layout": {
            "gapRem": 0.25,
            "direction": "column",
            "paddingRem": 0.5,
            "minWidthRem": 10
          },
          "children": [
            {
              "id": "uiselect-search-row",
              "tag": "div",
              "type": "frame",
              "style": {},
              "layout": {
                "width": {
                  "mode": "fill"
                },
                "position": "relative"
              },
              "children": [
                {
                  "id": "uiselect-search-input",
                  "tag": "input",
                  "type": "frame",
                  "attrs": {
                    "type": "text",
                    "value": "{{ state.search || '' }}",
                    "placeholder": "{{ props.searchInputPlaceholder }}"
                  },
                  "state": {
                    "_searchTmp": ""
                  },
                  "style": {
                    "raw": {
                      "outline": "none",
                      "box-sizing": "border-box"
                    },
                    "radiusRem": 0.375,
                    "textColor": "#F9F9F9",
                    "borderColor": "#454545",
                    "borderStyle": "solid",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    },
                    "borderWidthPx": 1,
                    "backgroundColor": "#323232"
                  },
                  "layout": {
                    "width": {
                      "mode": "fill"
                    },
                    "paddingRem": [0.5, 1.75, 0.5, 0.75]
                  },
                  "children": [],
                  "triggers": [
                    {
                      "on": "input",
                      "chain": [
                        {
                          "action": "readValue",
                          "target": "#_searchTmp",
                          "readFrom": "value"
                        },
                        {
                          "value": "{{state._searchTmp}}",
                          "action": "set",
                          "target": "#search"
                        }
                      ],
                      "action": "readValue",
                      "target": "#_searchTmp",
                      "readFrom": "value"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!!props.searchable"
                },
                {
                  "id": "uiselect-search-clear",
                  "tag": "button",
                  "text": "✕",
                  "type": "frame",
                  "attrs": {
                    "type": "button",
                    "aria-label": "Clear search"
                  },
                  "style": {
                    "raw": {
                      "top": "50%",
                      "border": "none",
                      "cursor": "pointer",
                      "transform": "translateY(-50%)",
                      "background": "transparent",
                      "line-height": "1"
                    },
                    "hover": {
                      "textColor": "#F9F9F9"
                    },
                    "textColor": "#696A6D",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    }
                  },
                  "layout": {
                    "position": "absolute",
                    "rightRem": 0.5,
                    "paddingRem": 0.25
                  },
                  "children": [],
                  "triggers": [
                    {
                      "on": "click",
                      "chain": [
                        {
                          "value": "",
                          "action": "set",
                          "target": "#search"
                        },
                        {
                          "value": "",
                          "action": "set",
                          "target": "#_searchTmp"
                        }
                      ],
                      "value": "",
                      "action": "set",
                      "target": "#search"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!!state.search"
                }
              ],
              "layoutMode": "flow",
              "visibleWhen": "!!props.searchable"
            },
            {
              "id": "uiselect-option-list",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gapRem": 0.25,
                "direction": "column"
              },
              "children": [
                {
                  "id": "uiselect-option-template",
                  "tag": "button",
                  "type": "frame",
                  "attrs": {
                    "type": "button"
                  },
                  "emits": ["option:click"],
                  "style": {
                    "raw": {
                      "cursor": "pointer",
                      "text-align": "left",
                      "font-family": "Inter, sans-serif",
                      "user-select": "none"
                    },
                    "hover": {
                      "backgroundColor": "#545456"
                    },
                    "modifiers": [
                      {
                        "expr": "!props.multiple && props.value && props.value.id === option.id",
                        "apply": {
                          "backgroundColor": "rgba(226,137,255,0.08)"
                        }
                      }
                    ],
                    "radiusRem": 0.375,
                    "textColor": "#F9F9F9",
                    "fontWeight": 400,
                    "fontSize": {
                      "mode": "px",
                      "value": 13
                    },
                    "borderWidthPx": 0,
                    "backgroundColor": "transparent"
                  },
                  "layout": {
                    "width": {
                      "mode": "fill"
                    },
                    "gapRem": 0.125,
                    "direction": "column",
                    "paddingRem": [0.5, 0.625, 0.5, 0.625]
                  },
                  "repeat": {
                    "as": "option",
                    "key": "value",
                    "over": "props.options",
                    "idTemplate": "uiselect-opt-{i}"
                  },
                  "children": [
                    {
                      "id": "opt-row-top",
                      "tag": "span",
                      "type": "frame",
                      "layout": {
                        "align": "center",
                        "width": {
                          "mode": "fill"
                        },
                        "gapRem": 0.375,
                        "justify": "space-between",
                        "direction": "row"
                      },
                      "children": [
                        {
                          "id": "opt-title-wrap",
                          "tag": "span",
                          "type": "frame",
                          "style": {
                            "raw": {
                              "min-width": "0"
                            }
                          },
                          "layout": {
                            "align": "center",
                            "gapRem": 0.375,
                            "direction": "row"
                          },
                          "children": [
                            {
                              "id": "uiselect-option-label",
                              "tag": "span",
                              "text": "{{ option.name || option.id }}",
                              "type": "frame",
                              "style": {
                                "raw": {
                                  "white-space": "nowrap",
                                  "text-overflow": "ellipsis"
                                },
                                "textColor": "#F9F9F9",
                                "fontSize": {
                                  "mode": "px",
                                  "value": 13
                                }
                              },
                              "layout": {},
                              "children": [],
                              "overflow": "hidden",
                              "layoutMode": "flow"
                            },
                            {
                              "id": "opt-badge",
                              "tag": "span",
                              "text": "{{ option.genres && option.genres[0] }}",
                              "type": "frame",
                              "style": {
                                "raw": {
                                  "line-height": "1.25",
                                  "letter-spacing": "0.02em"
                                },
                                "modifiers": [
                                  {
                                    "expr": "(option.genres && option.genres[0] === 'NSFW')",
                                    "apply": {
                                      "textColor": "rgb(251,75,87)",
                                      "backgroundColor": "rgba(251,75,87,0.16)"
                                    }
                                  }
                                ],
                                "radiusRem": 0.25,
                                "textColor": "rgb(103,255,121)",
                                "fontWeight": 700,
                                "fontSize": {
                                  "mode": "px",
                                  "value": 9.5
                                },
                                "backgroundColor": "rgba(103,255,121,0.12)"
                              },
                              "layout": {
                                "flexShrink": 0,
                                "paddingRem": [0.0625, 0.3125, 0.0625, 0.3125]
                              },
                              "children": [],
                              "layoutMode": "flow",
                              "visibleWhen": "!!(option.genres && option.genres[0])"
                            }
                          ],
                          "layoutMode": "flow"
                        },
                        {
                          "id": "uiselect-option-check",
                          "tag": "span",
                          "text": "✓",
                          "type": "frame",
                          "style": {
                            "textColor": "rgb(226,137,255)",
                            "fontSize": {
                              "mode": "px",
                              "value": 14
                            }
                          },
                          "layout": {
                            "flexShrink": 0
                          },
                          "children": [],
                          "layoutMode": "flow",
                          "visibleWhen": "props.multiple && props.value && props.value.some(o => o.id === option.id)"
                        }
                      ],
                      "layoutMode": "flow"
                    },
                    {
                      "id": "opt-description",
                      "tag": "span",
                      "text": "{{ option.description }}",
                      "type": "frame",
                      "style": {
                        "raw": {
                          "white-space": "nowrap",
                          "text-overflow": "ellipsis"
                        },
                        "textColor": "rgb(135,138,146)",
                        "fontSize": {
                          "mode": "px",
                          "value": 11
                        },
                        "lineHeight": {
                          "mode": "px",
                          "value": 16
                        }
                      },
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "layoutMode": "flow",
                      "visibleWhen": "!!option.description"
                    }
                  ],
                  "triggers": [
                    {
                      "on": "click",
                      "chain": [
                        {
                          "action": "emit",
                          "target": "option:click",
                          "payload": {
                            "id": "{{option.id}}",
                            "name": "{{option.name}}",
                            "genres": "{{option.genres}}",
                            "isDefault": "{{option.isDefault}}",
                            "badge": "{{option.genres && option.genres[0]}}",
                            "label": "{{option.name}}",
                            "value": "{{option.id}}",
                            "description": "{{option.description}}"
                          }
                        },
                        {
                          "value": false,
                          "action": "set",
                          "target": "#isOpen",
                          "condition": "!props.multiple && props.closeOnSelect"
                        }
                      ],
                      "action": "emit",
                      "target": "option:click",
                      "payload": {
                        "id": "{{option.id}}",
                        "name": "{{option.name}}",
                        "genres": "{{option.genres}}",
                        "isDefault": "{{option.isDefault}}",
                        "badge": "{{option.genres && option.genres[0]}}",
                        "label": "{{option.name}}",
                        "value": "{{option.id}}",
                        "description": "{{option.description}}"
                      }
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!state.search || ((option.name || option.id) + ' ' + (option.description || '')).toLowerCase().indexOf(state.search.toLowerCase()) > -1"
                }
              ],
              "layoutMode": "flow"
            }
          ],
          "layoutMode": "flow",
          "overlayDismiss": {
            "event": "escape"
          },
          "overlayTrigger": {
            "event": "state",
            "stateKey": "state.isOpen"
          },
          "overlayBackdrop": {
            "color": "transparent",
            "clickDismiss": true
          },
          "overlayPosition": {
            "anchor": "uiselect-trigger",
            "offset": 4,
            "placement": "bottom-start",
            "matchAnchor": "width"
          }
        },
        {
          "id": "uiselect-required-error",
          "tag": "span",
          "text": "COMMON.ERRORS.FILLED_IN",
          "type": "frame",
          "style": {
            "textColor": "#FB4B57",
            "fontSize": {
              "mode": "px",
              "value": 10
            }
          },
          "layout": {},
          "children": [],
          "layoutMode": "flow",
          "visibleWhen": "!!props.required"
        }
      ],
      "layoutMode": "flow",
      "__changeKey": "value"
    },
    "UiSelect Presets": {
      "id": "df36cb08",
      "on": {
        "tag:remove": {
          "chain": [
            {
              "value": null,
              "action": "set",
              "target": "props.value",
              "condition": "{{ props.value.length === 0 }}"
            }
          ],
          "value": "{{ emit }}",
          "action": "removeState",
          "target": "props.value"
        },
        "option:click": {
          "chain": [
            {
              "value": "{{ emit.option }}",
              "action": "set",
              "target": "props.value",
              "condition": "{{ !props.multiple }}"
            },
            {
              "value": "{{ props.value && props.value.some(o => o.value === emit.option.value) ? props.value.filter(o => o.value !== emit.option.value) : (props.value || []).concat([emit.option]) }}",
              "action": "set",
              "target": "props.value",
              "condition": "{{ props.multiple }}"
            },
            {
              "value": null,
              "action": "set",
              "target": "props.value",
              "condition": "{{ props.multiple && props.value && props.value.length === 0 }}"
            }
          ],
          "value": "{{ emit.option }}",
          "action": "set",
          "target": "props.value",
          "condition": "{{ !props.multiple }}"
        }
      },
      "tag": "div",
      "name": "UiSelect Presets",
      "type": "frame",
      "emits": ["change", "open", "close", "option:delete"],
      "props": {
        "value": {
          "type": "object",
          "default": null
        },
        "options": {
          "type": "array",
          "default": []
        },
        "disabled": {
          "type": "boolean",
          "default": false
        },
        "multiple": {
          "type": "boolean",
          "default": false
        },
        "required": {
          "type": "boolean",
          "default": false
        },
        "emptyText": {
          "type": "string",
          "default": ""
        },
        "searchable": {
          "type": "boolean",
          "default": false
        },
        "hasBackdrop": {
          "type": "boolean",
          "default": false
        },
        "placeholder": {
          "type": "string",
          "default": ""
        },
        "closeOnSelect": {
          "type": "boolean",
          "default": true
        },
        "dropdownWidth": {
          "type": "string",
          "default": "match-trigger"
        },
        "disableTagClick": {
          "type": "boolean",
          "default": false
        },
        "searchInputPlaceholder": {
          "type": "string",
          "default": ""
        }
      },
      "state": {
        "isOpen": false,
        "search": ""
      },
      "style": {
        "raw": {
          "min-width": "0",
          "box-sizing": "border-box"
        }
      },
      "layout": {
        "width": {
          "mode": "fill"
        },
        "gapRem": 1,
        "direction": "column"
      },
      "script": "\n    function setup(component) {\n      let _prev = component.state.isOpen === true;\n      component.watch(\n        () => component.state.isOpen,\n        (next) => {\n          const truthy = next === true;\n          if (truthy === _prev) return;\n          _prev = truthy;\n          component.emit(truthy ? 'open' : 'close', {});\n        },\n      );\n    }\n  ",
      "__source": "c359f068",
      "children": [
        {
          "id": "7f365f67",
          "tag": "button",
          "type": "frame",
          "attrs": {
            "type": "button",
            "disabled": "{{ props.disabled }}"
          },
          "style": {
            "raw": {
              "cursor": "pointer",
              "transition": "background-color 300ms ease, border-color 300ms ease-in-out",
              "user-select": "none"
            },
            "hover": {
              "backgroundColor": "#454545"
            },
            "disabled": {
              "backgroundColor": "#454545"
            },
            "modifiers": [
              {
                "expr": "state.isOpen",
                "apply": {
                  "borderColor": "rgb(226,137,255)"
                }
              },
              {
                "expr": "props.disabled",
                "apply": {
                  "raw": {
                    "cursor": "not-allowed"
                  }
                }
              }
            ],
            "radiusRem": 0.5,
            "textColor": "#B4B6BE",
            "borderColor": "#454545",
            "borderStyle": "solid",
            "fontSize": {
              "mode": "px",
              "value": 14
            },
            "borderWidthPx": 1,
            "lineHeight": {
              "mode": "px",
              "value": 20
            },
            "backgroundColor": "#323232"
          },
          "layout": {
            "align": "center",
            "width": {
              "mode": "fill"
            },
            "gapRem": 0.5,
            "height": {
              "mode": "px",
              "value": 38
            },
            "justify": "space-between",
            "direction": "row",
            "paddingRem": [0.75, 1, 0.75, 1]
          },
          "children": [
            {
              "id": "df5284a8",
              "tag": "div",
              "type": "frame",
              "style": {
                "raw": {
                  "min-width": "0"
                }
              },
              "layout": {
                "align": "center",
                "width": {
                  "mode": "fill"
                },
                "gapRem": 0.5,
                "direction": "row"
              },
              "children": [
                {
                  "id": "10d4b084",
                  "tag": "span",
                  "text": "{{ props.placeholder }}",
                  "type": "frame",
                  "style": {
                    "raw": {
                      "display": "block",
                      "max-width": "100%",
                      "white-space": "nowrap",
                      "text-overflow": "ellipsis"
                    },
                    "textColor": "#B4B6BE",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    },
                    "lineHeight": {
                      "mode": "px",
                      "value": 20
                    }
                  },
                  "layout": {},
                  "children": [],
                  "overflow": "hidden",
                  "layoutMode": "flow",
                  "visibleWhen": "(props.value == null || props.value.length === 0) && !!props.placeholder"
                },
                {
                  "id": "26d7e58f",
                  "tag": "div",
                  "type": "frame",
                  "style": {
                    "raw": {
                      "min-width": "0"
                    }
                  },
                  "layout": {
                    "align": "center",
                    "width": {
                      "mode": "fill"
                    },
                    "gapRem": 0.5,
                    "direction": "row"
                  },
                  "children": [
                    {
                      "id": "053ee449",
                      "tag": "span",
                      "text": "{{ props.value && (props.value.label || props.value.value) }}",
                      "type": "frame",
                      "style": {
                        "raw": {
                          "flex": "1 1 0%",
                          "text-align": "left",
                          "display": "block",
                          "max-width": "100%",
                          "min-width": "0",
                          "white-space": "nowrap",
                          "text-overflow": "ellipsis"
                        },
                        "textColor": "#F9F9F9",
                        "fontSize": {
                          "mode": "px",
                          "value": 14
                        },
                        "lineHeight": {
                          "mode": "px",
                          "value": 20
                        }
                      },
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!props.multiple && props.value != null",
                  "overflow": "hidden"
                },
                {
                  "id": "559cf7b2",
                  "tag": "div",
                  "type": "frame",
                  "layout": {
                    "wrap": "wrap",
                    "width": {
                      "mode": "fill"
                    },
                    "gapRem": 0.5,
                    "direction": "row"
                  },
                  "children": [
                    {
                      "id": "cf4e882c",
                      "tag": "div",
                      "type": "frame",
                      "emits": ["tag:remove"],
                      "style": {
                        "raw": {
                          "cursor": "pointer",
                          "user-select": "none"
                        },
                        "hover": {
                          "backgroundColor": "#323232"
                        },
                        "radiusRem": 0.5,
                        "textColor": "#F9F9F9",
                        "fontWeight": 400,
                        "fontSize": {
                          "mode": "px",
                          "value": 14
                        },
                        "borderWidthPx": 0,
                        "lineHeight": {
                          "mode": "px",
                          "value": 20
                        },
                        "backgroundColor": "#2B2B2B"
                      },
                      "layout": {
                        "align": "center",
                        "gapRem": 0.5,
                        "justify": "space-between",
                        "direction": "row",
                        "paddingRem": [0.25, 0.5, 0.25, 0.5],
                        "minWidthRem": 2.5,
                        "minHeightRem": 2
                      },
                      "repeat": {
                        "as": "tag",
                        "key": "value",
                        "over": "props.value",
                        "idTemplate": "uiselect-tag-{i}"
                      },
                      "children": [
                        {
                          "id": "926725df",
                          "tag": "span",
                          "text": "{{ tag.label || tag.value }}",
                          "type": "frame",
                          "style": {},
                          "layout": {},
                          "children": [],
                          "overflow": "hidden",
                          "layoutMode": "flow"
                        },
                        {
                          "id": "f0c78845",
                          "tag": "span",
                          "text": "✕",
                          "type": "frame",
                          "style": {
                            "raw": {
                              "user-select": "none"
                            },
                            "textColor": "#F9F9F9",
                            "fontSize": {
                              "mode": "px",
                              "value": 14
                            }
                          },
                          "layout": {},
                          "children": [],
                          "layoutMode": "flow"
                        }
                      ],
                      "triggers": [
                        {
                          "on": "click",
                          "action": "emit",
                          "target": "tag:remove",
                          "payload": {
                            "label": "{{tag.label}}",
                            "value": "{{tag.value}}"
                          }
                        }
                      ],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "props.multiple && props.value && props.value.length > 0"
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "94267dae",
              "tag": "span",
              "type": "frame",
              "style": {
                "raw": {
                  "color": "rgb(135, 138, 146)"
                }
              },
              "layout": {
                "flexShrink": 0
              },
              "children": [
                {
                  "id": "94267dae-icon",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "12",
                    "height": "12",
                    "viewBox": "0 0 12 12"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "94267dae-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M3 4.5l3 3 3-3",
                        "stroke": "currentColor",
                        "stroke-width": "1.4",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow"
                }
              ],
              "layoutMode": "flow",
              "visibleWhen": "!state.isOpen"
            },
            {
              "id": "c908723a",
              "tag": "span",
              "type": "frame",
              "style": {
                "raw": {
                  "color": "rgb(135, 138, 146)",
                  "transform": "rotate(180deg)"
                }
              },
              "layout": {
                "flexShrink": 0
              },
              "children": [
                {
                  "id": "c908723a-icon",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "12",
                    "height": "12",
                    "viewBox": "0 0 12 12"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "c908723a-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M3 4.5l3 3 3-3",
                        "stroke": "currentColor",
                        "stroke-width": "1.4",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow"
                }
              ],
              "layoutMode": "flow",
              "visibleWhen": "state.isOpen"
            }
          ],
          "triggers": [
            {
              "on": "click",
              "action": "toggle",
              "target": "#isOpen",
              "condition": "!props.disabled && !props.disableTagClick"
            }
          ],
          "layoutMode": "flow"
        },
        {
          "id": "6e0f339f",
          "tag": "div",
          "type": "overlay",
          "style": {
            "raw": {
              "width": "{{ props.dropdownWidth === \"fit-content\" ? \"max-content !important\" : (props.dropdownWidth === \"match-trigger\" || !props.dropdownWidth ? \"\" : props.dropdownWidth + \" !important\") }}",
              "overflow-y": "auto"
            },
            "radiusRem": 0.75,
            "backgroundColor": "#454545"
          },
          "layout": {
            "gapRem": 0.25,
            "direction": "column",
            "paddingRem": 0.5,
            "minWidthRem": 10
          },
          "children": [
            {
              "id": "ddc4fce5",
              "tag": "div",
              "type": "frame",
              "style": {},
              "layout": {
                "width": {
                  "mode": "fill"
                },
                "position": "relative"
              },
              "children": [
                {
                  "id": "search-lupa",
                  "tag": "span",
                  "type": "frame",
                  "style": {
                    "raw": {
                      "top": "50%",
                      "transform": "translateY(-50%)",
                      "pointer-events": "none"
                    },
                    "textColor": "#878A92"
                  },
                  "layout": {
                    "leftRem": 0.75,
                    "position": "absolute",
                    "align": "center",
                    "justify": "center"
                  },
                  "children": [
                    {
                      "id": "search-lupa-svg",
                      "tag": "svg",
                      "type": "frame",
                      "attrs": {
                        "fill": "none",
                        "width": "14",
                        "height": "14",
                        "viewBox": "0 0 16 16"
                      },
                      "style": {},
                      "layout": {},
                      "children": [
                        {
                          "id": "search-lupa-circle",
                          "tag": "circle",
                          "type": "frame",
                          "attrs": {
                            "r": "4.5",
                            "cx": "7",
                            "cy": "7",
                            "fill": "none",
                            "stroke": "currentColor",
                            "stroke-width": "1.4"
                          },
                          "style": {},
                          "layout": {},
                          "children": [],
                          "layoutMode": "flow"
                        },
                        {
                          "id": "search-lupa-path",
                          "tag": "path",
                          "type": "frame",
                          "attrs": {
                            "d": "M10.5 10.5l3 3",
                            "stroke": "currentColor",
                            "stroke-width": "1.4",
                            "stroke-linecap": "round"
                          },
                          "style": {},
                          "layout": {},
                          "children": [],
                          "layoutMode": "flow"
                        }
                      ],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!!props.searchable"
                },
                {
                  "id": "72e97c70",
                  "tag": "input",
                  "type": "frame",
                  "attrs": {
                    "type": "text",
                    "value": "{{ state.search || '' }}",
                    "placeholder": "{{ props.searchInputPlaceholder }}"
                  },
                  "state": {
                    "_searchTmp": ""
                  },
                  "style": {
                    "raw": {
                      "outline": "none",
                      "box-sizing": "border-box",
                      "min-width": "0"
                    },
                    "radiusRem": 0.375,
                    "textColor": "#F9F9F9",
                    "borderColor": "#454545",
                    "borderStyle": "solid",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    },
                    "borderWidthPx": 1,
                    "backgroundColor": "#323232"
                  },
                  "layout": {
                    "width": {
                      "mode": "fill"
                    },
                    "paddingRem": [0.5, 1.75, 0.5, 2.25]
                  },
                  "children": [],
                  "triggers": [
                    {
                      "on": "input",
                      "chain": [
                        {
                          "action": "readValue",
                          "target": "#_searchTmp",
                          "readFrom": "value"
                        },
                        {
                          "value": "{{state._searchTmp}}",
                          "action": "set",
                          "target": "#search"
                        }
                      ],
                      "action": "readValue",
                      "target": "#_searchTmp",
                      "readFrom": "value"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!!props.searchable"
                },
                {
                  "id": "532d2bbf",
                  "tag": "button",
                  "text": "✕",
                  "type": "frame",
                  "attrs": {
                    "type": "button",
                    "aria-label": "Clear search"
                  },
                  "style": {
                    "raw": {
                      "top": "50%",
                      "border": "none",
                      "cursor": "pointer",
                      "transform": "translateY(-50%)",
                      "background": "transparent",
                      "line-height": "1"
                    },
                    "hover": {
                      "textColor": "#F9F9F9"
                    },
                    "textColor": "#696A6D",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    }
                  },
                  "layout": {
                    "position": "absolute",
                    "rightRem": 0.5,
                    "paddingRem": 0.25
                  },
                  "children": [],
                  "triggers": [
                    {
                      "on": "click",
                      "chain": [
                        {
                          "value": "",
                          "action": "set",
                          "target": "#search"
                        },
                        {
                          "value": "",
                          "action": "set",
                          "target": "#_searchTmp"
                        }
                      ],
                      "value": "",
                      "action": "set",
                      "target": "#search"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!!state.search"
                }
              ],
              "layoutMode": "flow",
              "visibleWhen": "!!props.searchable"
            },
            {
              "id": "9a6451a9",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gapRem": 0.25,
                "direction": "column"
              },
              "children": [
                {
                  "id": "c00ff1e2",
                  "tag": "div",
                  "type": "frame",
                  "style": {
                    "raw": {
                      "transition": "background-color 120ms ease"
                    },
                    "hover": {
                      "backgroundColor": "#545456"
                    },
                    "modifiers": [
                      {
                        "expr": "!props.multiple && props.value && props.value.value === option.value",
                        "apply": {
                          "backgroundColor": "rgba(226,137,255,0.08)"
                        }
                      }
                    ],
                    "radiusRem": 0.375,
                    "backgroundColor": "transparent"
                  },
                  "layout": {
                    "width": {
                      "mode": "fill"
                    },
                    "position": "relative",
                    "direction": "row"
                  },
                  "repeat": {
                    "as": "option",
                    "key": "value",
                    "over": "props.options",
                    "idTemplate": "uiselect-opt-{i}"
                  },
                  "children": [
                    {
                      "id": "opt-main-btn",
                      "tag": "button",
                      "type": "frame",
                      "attrs": {
                        "type": "button"
                      },
                      "emits": ["option:click"],
                      "style": {
                        "raw": {
                          "border": "0",
                          "cursor": "pointer",
                          "min-width": "0",
                          "background": "transparent",
                          "text-align": "left",
                          "font-family": "Inter"
                        }
                      },
                      "layout": {
                        "width": {
                          "mode": "fill"
                        },
                        "gapRem": 0.0625,
                        "direction": "column",
                        "paddingRem": [0.375, 2.25, 0.375, 0.5]
                      },
                      "children": [
                        {
                          "id": "opt-title-row",
                          "tag": "div",
                          "type": "frame",
                          "style": {
                            "raw": {
                              "min-width": "0"
                            }
                          },
                          "layout": {
                            "align": "center",
                            "width": {
                              "mode": "fill"
                            },
                            "gapRem": 0.375,
                            "direction": "row"
                          },
                          "children": [
                            {
                              "id": "opt-title",
                              "tag": "span",
                              "text": "{{ option.label || option.value }}",
                              "type": "frame",
                              "style": {
                                "raw": {
                                  "flex": "1 1 0%",
                                  "display": "block",
                                  "min-width": "0",
                                  "white-space": "nowrap",
                                  "text-overflow": "ellipsis"
                                },
                                "textColor": "#F9F9F9",
                                "fontWeight": 500,
                                "fontSize": {
                                  "mode": "px",
                                  "value": 13
                                }
                              },
                              "layout": {},
                              "children": [],
                              "layoutMode": "flow",
                              "overflow": "hidden"
                            },
                            {
                              "id": "da9378c3",
                              "tag": "span",
                              "text": "✓",
                              "type": "frame",
                              "style": {
                                "textColor": "#FF9F32",
                                "fontSize": {
                                  "mode": "px",
                                  "value": 16
                                }
                              },
                              "layout": {
                                "flexShrink": 0
                              },
                              "children": [],
                              "layoutMode": "flow",
                              "visibleWhen": "props.multiple && props.value && props.value.some(o => o.value === option.value)"
                            }
                          ],
                          "layoutMode": "flow",
                          "overflow": "hidden"
                        },
                        {
                          "id": "opt-subtitle",
                          "tag": "span",
                          "text": "{{ option.model ? (((globals.imageModels || []).find(m => m.id === option.model) ? (globals.imageModels || []).find(m => m.id === option.model).name : option.model) + ' · CFG ' + option.cfgScale + ' · ' + option.steps + ' steps · ' + option.resolution) : (option.description || '') }}",
                          "type": "frame",
                          "style": {
                            "raw": {
                              "display": "block",
                              "max-width": "100%",
                              "white-space": "nowrap",
                              "text-overflow": "ellipsis"
                            },
                            "textColor": "#878A92",
                            "fontSize": {
                              "mode": "px",
                              "value": 11
                            }
                          },
                          "layout": {},
                          "children": [],
                          "layoutMode": "flow",
                          "visibleWhen": "!!option.description || !!option.model",
                          "overflow": "hidden"
                        }
                      ],
                      "triggers": [
                        {
                          "on": "click",
                          "chain": [
                            {
                              "action": "emit",
                              "target": "option:click",
                              "payload": {
                                "option": "{{ option }}"
                              }
                            },
                            {
                              "value": false,
                              "action": "set",
                              "target": "#isOpen",
                              "condition": "!props.multiple && props.closeOnSelect"
                            }
                          ],
                          "action": "emit",
                          "target": "option:click",
                          "payload": {
                            "option": "{{ option }}"
                          }
                        }
                      ],
                      "layoutMode": "flow"
                    },
                    {
                      "id": "opt-delete-btn",
                      "tag": "button",
                      "type": "frame",
                      "attrs": {
                        "type": "button",
                        "title": "Delete preset",
                        "aria-label": "Delete preset"
                      },
                      "emits": ["option:delete"],
                      "style": {
                        "raw": {
                          "top": "50%",
                          "border": "0",
                          "cursor": "pointer",
                          "transform": "translateY(-50%)",
                          "background": "transparent",
                          "transition": "color 120ms ease, background-color 120ms ease"
                        },
                        "hover": {
                          "textColor": "#FB4B57",
                          "backgroundColor": "rgba(251,75,87,0.12)"
                        },
                        "radiusRem": 0.375,
                        "textColor": "#878A92"
                      },
                      "layout": {
                        "width": {
                          "mode": "rem",
                          "value": 1.5
                        },
                        "height": {
                          "mode": "px",
                          "value": 24
                        },
                        "position": "absolute",
                        "rightRem": 0.375,
                        "align": "center",
                        "justify": "center"
                      },
                      "children": [
                        {
                          "id": "opt-delete-icon",
                          "tag": "svg",
                          "type": "frame",
                          "attrs": {
                            "fill": "none",
                            "width": "14",
                            "height": "14",
                            "viewBox": "0 0 16 16"
                          },
                          "style": {},
                          "layout": {},
                          "children": [
                            {
                              "id": "opt-delete-path",
                              "tag": "path",
                              "type": "frame",
                              "attrs": {
                                "d": "M3 4.5h10M6 4.5V3a1 1 0 011-1h2a1 1 0 011 1v1.5M5 4.5l.5 8.5a1 1 0 001 1h3a1 1 0 001-1l.5-8.5",
                                "stroke": "currentColor",
                                "stroke-width": "1.4",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              },
                              "style": {},
                              "layout": {},
                              "children": [],
                              "layoutMode": "flow"
                            }
                          ],
                          "layoutMode": "flow"
                        }
                      ],
                      "triggers": [
                        {
                          "on": "click",
                          "action": "emit",
                          "target": "option:delete",
                          "payload": {
                            "option": "{{ option }}"
                          }
                        }
                      ],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!state.search || (option.label || option.value).toLowerCase().indexOf(state.search.toLowerCase()) > -1"
                },
                {
                  "id": "opt-empty",
                  "tag": "div",
                  "type": "frame",
                  "style": {
                    "textColor": "#878A92",
                    "fontSize": {
                      "mode": "px",
                      "value": 13
                    },
                    "lineHeight": {
                      "mode": "px",
                      "value": 24
                    }
                  },
                  "layout": {
                    "align": "center",
                    "width": {
                      "mode": "fill"
                    },
                    "justify": "center",
                    "direction": "column",
                    "paddingRem": [1, 0.75, 1, 0.75]
                  },
                  "children": [
                    {
                      "id": "opt-empty-text",
                      "tag": "span",
                      "text": "{{ props.emptyText || (state.search ? 'Ничего не найдено' : 'Нет пресетов') }}",
                      "type": "frame",
                      "style": {},
                      "layout": {},
                      "children": [],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!props.options || props.options.length === 0 || (!!state.search && !props.options.some(o => (o.label || o.value).toLowerCase().indexOf(state.search.toLowerCase()) > -1))"
                }
              ],
              "layoutMode": "flow"
            }
          ],
          "layoutMode": "flow",
          "overlayDismiss": {
            "event": "escape"
          },
          "overlayTrigger": {
            "event": "state",
            "stateKey": "state.isOpen"
          },
          "overlayBackdrop": {
            "color": "transparent",
            "clickDismiss": true
          },
          "overlayPosition": {
            "anchor": "7f365f67",
            "offset": 4,
            "placement": "bottom-start",
            "matchAnchor": "width"
          }
        },
        {
          "id": "5de40be1",
          "tag": "span",
          "text": "COMMON.ERRORS.FILLED_IN",
          "type": "frame",
          "style": {
            "textColor": "#FB4B57",
            "fontSize": {
              "mode": "px",
              "value": 10
            }
          },
          "layout": {},
          "children": [],
          "layoutMode": "flow",
          "visibleWhen": "!!props.required"
        }
      ],
      "layoutMode": "flow"
    },
    "UiSelect Primary": {
      "id": "c359f068",
      "on": {
        "tag:remove": {
          "chain": [
            {
              "value": null,
              "action": "set",
              "target": "props.value",
              "condition": "{{ props.value.length === 0 }}"
            }
          ],
          "value": "{{ emit }}",
          "action": "removeState",
          "target": "props.value"
        },
        "option:click": {
          "chain": [
            {
              "value": "{{ emit }}",
              "action": "set",
              "target": "props.value",
              "condition": "{{ !props.multiple }}"
            },
            {
              "value": "{{ props.value && props.value.some(o => o.value === emit.value) ? props.value.filter(o => o.value !== emit.value) : (props.value || []).concat([emit]) }}",
              "action": "set",
              "target": "props.value",
              "condition": "{{ props.multiple }}"
            },
            {
              "value": null,
              "action": "set",
              "target": "props.value",
              "condition": "{{ props.multiple && props.value && props.value.length === 0 }}"
            }
          ],
          "value": "{{ emit }}",
          "action": "set",
          "target": "props.value",
          "condition": "{{ !props.multiple }}"
        }
      },
      "tag": "div",
      "name": "UiSelect Primary",
      "type": "frame",
      "emits": ["change", "open", "close"],
      "props": {
        "value": {
          "type": "object",
          "default": null
        },
        "options": {
          "type": "array",
          "default": []
        },
        "disabled": {
          "type": "boolean",
          "default": false
        },
        "multiple": {
          "type": "boolean",
          "default": false
        },
        "required": {
          "type": "boolean",
          "default": false
        },
        "searchable": {
          "type": "boolean",
          "default": false
        },
        "hasBackdrop": {
          "type": "boolean",
          "default": false
        },
        "placeholder": {
          "type": "string",
          "default": ""
        },
        "closeOnSelect": {
          "type": "boolean",
          "default": true
        },
        "dropdownWidth": {
          "type": "string",
          "default": "match-trigger"
        },
        "disableTagClick": {
          "type": "boolean",
          "default": false
        },
        "searchInputPlaceholder": {
          "type": "string",
          "default": ""
        }
      },
      "state": {
        "isOpen": false,
        "search": ""
      },
      "style": {
        "raw": {
          "box-sizing": "border-box"
        }
      },
      "layout": {
        "width": {
          "mode": "fill"
        },
        "gapRem": 1,
        "direction": "column"
      },
      "script": "\n    function setup(component) {\n      let _prev = component.state.isOpen === true;\n      component.watch(\n        () => component.state.isOpen,\n        (next) => {\n          const truthy = next === true;\n          if (truthy === _prev) return;\n          _prev = truthy;\n          component.emit(truthy ? 'open' : 'close', {});\n        },\n      );\n    }\n  ",
      "__source": "uiselect-root",
      "children": [
        {
          "id": "19d17dc1",
          "tag": "button",
          "type": "frame",
          "attrs": {
            "type": "button",
            "disabled": "{{ props.disabled }}"
          },
          "style": {
            "raw": {
              "cursor": "pointer",
              "transition": "background-color 300ms ease, border-color 300ms ease-in-out",
              "user-select": "none"
            },
            "hover": {
              "backgroundColor": "#454545"
            },
            "disabled": {
              "backgroundColor": "#454545"
            },
            "modifiers": [
              {
                "expr": "state.isOpen",
                "apply": {
                  "borderColor": "rgb(226,137,255)"
                }
              },
              {
                "expr": "props.disabled",
                "apply": {
                  "raw": {
                    "cursor": "not-allowed"
                  }
                }
              }
            ],
            "radiusRem": 0.5,
            "textColor": "#B4B6BE",
            "borderColor": "#454545",
            "borderStyle": "solid",
            "fontSize": {
              "mode": "px",
              "value": 14
            },
            "borderWidthPx": 1,
            "lineHeight": {
              "mode": "px",
              "value": 20
            },
            "backgroundColor": "#323232"
          },
          "layout": {
            "align": "center",
            "width": {
              "mode": "fill"
            },
            "gapRem": 0.5,
            "height": {
              "mode": "px",
              "value": 38
            },
            "justify": "space-between",
            "direction": "row",
            "paddingRem": [0.75, 1, 0.75, 1],
            "minWidthRem": 9
          },
          "children": [
            {
              "id": "98d7179d",
              "tag": "div",
              "type": "frame",
              "style": {
                "raw": {
                  "min-width": "0"
                }
              },
              "layout": {
                "align": "center",
                "width": {
                  "mode": "fill"
                },
                "gapRem": 0.5,
                "direction": "row"
              },
              "children": [
                {
                  "id": "1f5d8216",
                  "tag": "span",
                  "text": "{{ props.placeholder }}",
                  "type": "frame",
                  "style": {
                    "textColor": "#B4B6BE",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    },
                    "lineHeight": {
                      "mode": "px",
                      "value": 20
                    }
                  },
                  "layout": {},
                  "children": [],
                  "overflow": "hidden",
                  "layoutMode": "flow",
                  "visibleWhen": "(props.value == null || props.value.length === 0) && !!props.placeholder"
                },
                {
                  "id": "deafb095",
                  "tag": "div",
                  "type": "frame",
                  "style": {
                    "raw": {
                      "min-width": "0"
                    }
                  },
                  "layout": {
                    "align": "center",
                    "width": {
                      "mode": "fill"
                    },
                    "gapRem": 0.5,
                    "direction": "row"
                  },
                  "children": [
                    {
                      "id": "5fd3fffd",
                      "tag": "span",
                      "text": "{{ props.value && (props.value.label || props.value.value) }}",
                      "type": "frame",
                      "style": {
                        "textColor": "#F9F9F9",
                        "fontSize": {
                          "mode": "px",
                          "value": 14
                        },
                        "lineHeight": {
                          "mode": "px",
                          "value": 20
                        }
                      },
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!props.multiple && props.value != null"
                },
                {
                  "id": "e8391695",
                  "tag": "div",
                  "type": "frame",
                  "layout": {
                    "wrap": "wrap",
                    "width": {
                      "mode": "fill"
                    },
                    "gapRem": 0.5,
                    "direction": "row"
                  },
                  "children": [
                    {
                      "id": "9f625553",
                      "tag": "div",
                      "type": "frame",
                      "emits": ["tag:remove"],
                      "style": {
                        "raw": {
                          "cursor": "pointer",
                          "user-select": "none"
                        },
                        "hover": {
                          "backgroundColor": "#323232"
                        },
                        "radiusRem": 0.5,
                        "textColor": "#F9F9F9",
                        "fontWeight": 400,
                        "fontSize": {
                          "mode": "px",
                          "value": 14
                        },
                        "borderWidthPx": 0,
                        "lineHeight": {
                          "mode": "px",
                          "value": 20
                        },
                        "backgroundColor": "#2B2B2B"
                      },
                      "layout": {
                        "align": "center",
                        "gapRem": 0.5,
                        "justify": "space-between",
                        "direction": "row",
                        "paddingRem": [0.25, 0.5, 0.25, 0.5],
                        "minWidthRem": 2.5,
                        "minHeightRem": 2
                      },
                      "repeat": {
                        "as": "tag",
                        "key": "value",
                        "over": "props.value",
                        "idTemplate": "uiselect-tag-{i}"
                      },
                      "children": [
                        {
                          "id": "95f53810",
                          "tag": "span",
                          "text": "{{ tag.label || tag.value }}",
                          "type": "frame",
                          "style": {},
                          "layout": {},
                          "children": [],
                          "overflow": "hidden",
                          "layoutMode": "flow"
                        },
                        {
                          "id": "d2a12b9b",
                          "tag": "span",
                          "text": "✕",
                          "type": "frame",
                          "style": {
                            "raw": {
                              "user-select": "none"
                            },
                            "textColor": "#F9F9F9",
                            "fontSize": {
                              "mode": "px",
                              "value": 14
                            }
                          },
                          "layout": {},
                          "children": [],
                          "layoutMode": "flow"
                        }
                      ],
                      "triggers": [
                        {
                          "on": "click",
                          "action": "emit",
                          "target": "tag:remove",
                          "payload": {
                            "label": "{{tag.label}}",
                            "value": "{{tag.value}}"
                          }
                        }
                      ],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "props.multiple && props.value && props.value.length > 0"
                }
              ],
              "layoutMode": "flow"
            },
            {
              "id": "cee997f4",
              "tag": "span",
              "type": "frame",
              "style": {
                "raw": {
                  "color": "rgb(135, 138, 146)"
                }
              },
              "layout": {
                "flexShrink": 0
              },
              "children": [
                {
                  "id": "cee997f4-icon",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "12",
                    "height": "12",
                    "viewBox": "0 0 12 12"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "cee997f4-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M3 4.5l3 3 3-3",
                        "stroke": "currentColor",
                        "stroke-width": "1.4",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow"
                }
              ],
              "layoutMode": "flow",
              "visibleWhen": "!state.isOpen"
            },
            {
              "id": "22b71ac8",
              "tag": "span",
              "type": "frame",
              "style": {
                "raw": {
                  "color": "rgb(135, 138, 146)",
                  "transform": "rotate(180deg)"
                }
              },
              "layout": {
                "flexShrink": 0
              },
              "children": [
                {
                  "id": "22b71ac8-icon",
                  "tag": "svg",
                  "type": "frame",
                  "attrs": {
                    "fill": "none",
                    "width": "12",
                    "height": "12",
                    "viewBox": "0 0 12 12"
                  },
                  "layout": {},
                  "children": [
                    {
                      "id": "22b71ac8-path",
                      "tag": "path",
                      "type": "frame",
                      "attrs": {
                        "d": "M3 4.5l3 3 3-3",
                        "stroke": "currentColor",
                        "stroke-width": "1.4",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "flow"
                    }
                  ],
                  "layoutMode": "flow"
                }
              ],
              "layoutMode": "flow",
              "visibleWhen": "state.isOpen"
            }
          ],
          "triggers": [
            {
              "on": "click",
              "action": "toggle",
              "target": "#isOpen",
              "condition": "!props.disabled && !props.disableTagClick"
            }
          ],
          "layoutMode": "flow"
        },
        {
          "id": "daa9f8f5",
          "tag": "div",
          "type": "overlay",
          "style": {
            "raw": {
              "width": "{{ props.dropdownWidth === \"fit-content\" ? \"max-content !important\" : (props.dropdownWidth === \"match-trigger\" || !props.dropdownWidth ? \"\" : props.dropdownWidth + \" !important\") }}",
              "overflow-y": "auto"
            },
            "radiusRem": 0.75,
            "backgroundColor": "#454545"
          },
          "layout": {
            "gapRem": 0.25,
            "direction": "column",
            "paddingRem": 0.5,
            "minWidthRem": 10
          },
          "children": [
            {
              "id": "39e9af13",
              "tag": "div",
              "type": "frame",
              "style": {},
              "layout": {
                "width": {
                  "mode": "fill"
                },
                "position": "relative"
              },
              "children": [
                {
                  "id": "20405783",
                  "tag": "input",
                  "type": "frame",
                  "attrs": {
                    "type": "text",
                    "value": "{{ state.search || '' }}",
                    "placeholder": "{{ props.searchInputPlaceholder }}"
                  },
                  "state": {
                    "_searchTmp": ""
                  },
                  "style": {
                    "raw": {
                      "outline": "none",
                      "box-sizing": "border-box"
                    },
                    "radiusRem": 0.375,
                    "textColor": "#F9F9F9",
                    "borderColor": "#454545",
                    "borderStyle": "solid",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    },
                    "borderWidthPx": 1,
                    "backgroundColor": "#323232"
                  },
                  "layout": {
                    "width": {
                      "mode": "fill"
                    },
                    "paddingRem": [0.5, 1.75, 0.5, 0.75]
                  },
                  "children": [],
                  "triggers": [
                    {
                      "on": "input",
                      "chain": [
                        {
                          "action": "readValue",
                          "target": "#_searchTmp",
                          "readFrom": "value"
                        },
                        {
                          "value": "{{state._searchTmp}}",
                          "action": "set",
                          "target": "#search"
                        }
                      ],
                      "action": "readValue",
                      "target": "#_searchTmp",
                      "readFrom": "value"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!!props.searchable"
                },
                {
                  "id": "3723d0b7",
                  "tag": "button",
                  "text": "✕",
                  "type": "frame",
                  "attrs": {
                    "type": "button",
                    "aria-label": "Clear search"
                  },
                  "style": {
                    "raw": {
                      "top": "50%",
                      "border": "none",
                      "cursor": "pointer",
                      "transform": "translateY(-50%)",
                      "background": "transparent",
                      "line-height": "1"
                    },
                    "hover": {
                      "textColor": "#F9F9F9"
                    },
                    "textColor": "#696A6D",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    }
                  },
                  "layout": {
                    "position": "absolute",
                    "rightRem": 0.5,
                    "paddingRem": 0.25
                  },
                  "children": [],
                  "triggers": [
                    {
                      "on": "click",
                      "chain": [
                        {
                          "value": "",
                          "action": "set",
                          "target": "#search"
                        },
                        {
                          "value": "",
                          "action": "set",
                          "target": "#_searchTmp"
                        }
                      ],
                      "value": "",
                      "action": "set",
                      "target": "#search"
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!!state.search"
                }
              ],
              "layoutMode": "flow",
              "visibleWhen": "!!props.searchable"
            },
            {
              "id": "67ba195a",
              "tag": "div",
              "type": "frame",
              "layout": {
                "gapRem": 0.25,
                "direction": "column"
              },
              "children": [
                {
                  "id": "668383d2",
                  "tag": "div",
                  "type": "frame",
                  "emits": ["option:click"],
                  "style": {
                    "raw": {
                      "cursor": "pointer",
                      "user-select": "none"
                    },
                    "hover": {
                      "backgroundColor": "#545456"
                    },
                    "modifiers": [
                      {
                        "expr": "!props.multiple && props.value && props.value.value === option.value",
                        "apply": {
                          "backgroundColor": "rgba(226,137,255,0.08)"
                        }
                      }
                    ],
                    "radiusRem": 0.5,
                    "textColor": "#F9F9F9",
                    "fontSize": {
                      "mode": "px",
                      "value": 14
                    },
                    "lineHeight": {
                      "mode": "px",
                      "value": 24
                    },
                    "backgroundColor": "#454545"
                  },
                  "layout": {
                    "align": "center",
                    "width": {
                      "mode": "fill"
                    },
                    "justify": "space-between",
                    "direction": "row",
                    "paddingRem": 0.5
                  },
                  "repeat": {
                    "as": "option",
                    "key": "value",
                    "over": "props.options",
                    "idTemplate": "uiselect-opt-{i}"
                  },
                  "children": [
                    {
                      "id": "09806359",
                      "tag": "span",
                      "text": "{{ option.label || option.value }}",
                      "type": "frame",
                      "style": {},
                      "layout": {},
                      "children": [],
                      "overflow": "hidden",
                      "layoutMode": "flow"
                    },
                    {
                      "id": "77a3e86e",
                      "tag": "span",
                      "text": "✓",
                      "type": "frame",
                      "style": {
                        "textColor": "#FF9F32",
                        "fontSize": {
                          "mode": "px",
                          "value": 20
                        }
                      },
                      "layout": {},
                      "children": [],
                      "layoutMode": "flow",
                      "visibleWhen": "props.multiple && props.value && props.value.some(o => o.value === option.value)"
                    }
                  ],
                  "triggers": [
                    {
                      "on": "click",
                      "chain": [
                        {
                          "action": "emit",
                          "target": "option:click",
                          "payload": {
                            "label": "{{option.label}}",
                            "value": "{{option.value}}"
                          }
                        },
                        {
                          "value": false,
                          "action": "set",
                          "target": "#isOpen",
                          "condition": "!props.multiple && props.closeOnSelect"
                        }
                      ]
                    }
                  ],
                  "layoutMode": "flow",
                  "visibleWhen": "!state.search || (option.label || option.value).toLowerCase().indexOf(state.search.toLowerCase()) > -1"
                }
              ],
              "layoutMode": "flow"
            }
          ],
          "layoutMode": "flow",
          "overlayDismiss": {
            "event": "escape"
          },
          "overlayTrigger": {
            "event": "state",
            "stateKey": "state.isOpen"
          },
          "overlayBackdrop": {
            "color": "transparent",
            "clickDismiss": true
          },
          "overlayPosition": {
            "anchor": "19d17dc1",
            "offset": 4,
            "placement": "bottom-start",
            "matchAnchor": "width"
          }
        },
        {
          "id": "1e14e2be",
          "tag": "span",
          "text": "COMMON.ERRORS.FILLED_IN",
          "type": "frame",
          "style": {
            "textColor": "#FB4B57",
            "fontSize": {
              "mode": "px",
              "value": 10
            }
          },
          "layout": {},
          "children": [],
          "layoutMode": "flow",
          "visibleWhen": "!!props.required"
        }
      ],
      "layoutMode": "flow"
    },
    "IgConfirmDeleteModal": {
      "id": "ConfirmDeleteModal",
      "tag": "div",
      "type": "frame",
      "emits": ["confirm", "cancel"],
      "props": {
        "item": {
          "type": "object",
          "default": {
            "qty": 4,
            "name": "Зелье здоровья",
            "color": "#FB4B57",
            "iconPath": "M12 3s6 6 6 11a6 6 0 11-12 0c0-5 6-11 6-11z"
          },
          "required": false
        },
        "title": {
          "type": "string",
          "default": "Delete image?"
        },
        "message": {
          "type": "string",
          "default": "This image will be permanently removed from your gallery. This action cannot be undone."
        },
        "cancelLabel": {
          "type": "string",
          "default": "Cancel"
        },
        "confirmLabel": {
          "type": "string",
          "default": "Delete"
        }
      },
      "style": {
        "raw": {
          "background": "#2B2B2B",
          "box-shadow": "0 16px 48px rgba(0,0,0,0.5)",
          "transition": "border-color 0.15s, transform 0.15s"
        },
        "hover": {
          "borderColor": "#454545"
        },
        "radius": {
          "mode": "px",
          "value": 12
        },
        "borderColor": "rgb(47,47,47)",
        "borderStyle": "solid",
        "borderWidthPx": 1
      },
      "layout": {
        "gap": {
          "mode": "px",
          "value": 16
        },
        "width": {
          "mode": "percent",
          "value": 100
        },
        "padding": {
          "mode": "px",
          "value": 16
        },
        "direction": "column",
        "minHeight": {
          "mode": "px",
          "value": 0
        },
        "maxWidthRem": 27
      },
      "children": [
        {
          "id": "confirm-header",
          "tag": "div",
          "type": "frame",
          "style": {},
          "layout": {
            "align": "center",
            "justify": "center",
            "width": {
              "mode": "percent",
              "value": 100
            },
            "minHeight": {
              "mode": "px",
              "value": 18
            },
            "position": "relative"
          },
          "children": [
            {
              "id": "confirm-title",
              "tag": "div",
              "text": "{{props.title}}",
              "type": "frame",
              "style": {
                "raw": {
                  "text-align": "center",
                  "line-height": "2rem"
                },
                "fontSize": {
                  "mode": "rem",
                  "value": 1.5
                },
                "textColor": "#F9F9F9",
                "fontWeight": 500
              },
              "layout": {},
              "children": [],
              "overflow": "hidden",
              "cssClasses": ["confirm-title"],
              "layoutMode": "auto"
            },
            {
              "id": "confirm-close",
              "tag": "span",
              "text": "×",
              "type": "frame",
              "style": {
                "raw": {
                  "cursor": "pointer",
                  "right": "0",
                  "text-align": "center",
                  "transition": "color 0.15s",
                  "font-family": "system-ui, -apple-system, sans-serif",
                  "line-height": "24px",
                  "user-select": "none"
                },
                "hover": {
                  "textColor": "#F9F9F9"
                },
                "fontSize": {
                  "mode": "px",
                  "value": 24
                },
                "textColor": "#696A6D",
                "fontWeight": 300
              },
              "layout": {
                "align": "center",
                "width": {
                  "mode": "px",
                  "value": 24
                },
                "height": {
                  "mode": "px",
                  "value": 24
                },
                "justify": "center",
                "position": "absolute"
              },
              "children": [],
              "triggers": [
                {
                  "on": "click",
                  "action": "emit",
                  "target": "cancel"
                }
              ],
              "cssClasses": ["confirm-close"],
              "layoutMode": "auto"
            }
          ],
          "cssClasses": ["confirm-header"],
          "layoutMode": "flow"
        },
        {
          "id": "confirm-message",
          "tag": "div",
          "text": "{{props.message}}",
          "type": "frame",
          "style": {
            "raw": {
              "text-align": "center"
            },
            "fontSize": {
              "mode": "px",
              "value": 16
            },
            "textColor": "#CED0D5",
            "fontWeight": 400,
            "lineHeight": {
              "mode": "px",
              "value": 24
            }
          },
          "layout": {},
          "children": [],
          "cssClasses": ["confirm-message"],
          "layoutMode": "auto"
        },
        {
          "id": "confirm-actions",
          "tag": "div",
          "type": "frame",
          "layout": {
            "gap": {
              "mode": "px",
              "value": 16
            },
            "width": {
              "mode": "percent",
              "value": 100
            },
            "minHeight": {
              "mode": "px",
              "value": 18
            }
          },
          "children": [
            {
              "id": "confirm-cancel-btn",
              "tag": "button",
              "text": "{{props.cancelLabel}}",
              "type": "frame",
              "style": {
                "raw": {
                  "cursor": "pointer",
                  "flex": "1 1 0%",
                  "background": "#454545",
                  "transition": "background 0.15s",
                  "white-space": "nowrap",
                  "line-height": "1"
                },
                "hover": {
                  "backgroundColor": "#545456"
                },
                "radius": {
                  "mode": "px",
                  "value": 8
                },
                "fontSize": {
                  "mode": "px",
                  "value": 14
                },
                "textColor": "#F9F9F9",
                "fontWeight": 400,
                "borderColor": "transparent",
                "borderStyle": "solid",
                "borderWidthPx": 1
              },
              "layout": {
                "align": "center",
                "justify": "center",
                "height": {
                  "mode": "px",
                  "value": 38
                },
                "padding": [
                  {
                    "mode": "px",
                    "value": 8
                  },
                  {
                    "mode": "px",
                    "value": 16
                  }
                ]
              },
              "children": [],
              "triggers": [
                {
                  "on": "click",
                  "action": "emit",
                  "target": "cancel"
                }
              ],
              "cssClasses": ["confirm-btn", "confirm-btn-secondary"],
              "layoutMode": "auto"
            },
            {
              "id": "confirm-confirm-btn",
              "tag": "button",
              "text": "{{props.confirmLabel}}",
              "type": "frame",
              "style": {
                "raw": {
                  "cursor": "pointer",
                  "flex": "1 1 0%",
                  "background": "#FB4B57",
                  "transition": "background 0.15s, transform 0.15s",
                  "white-space": "nowrap",
                  "line-height": "1"
                },
                "hover": {
                  "backgroundColor": "#FF6B75"
                },
                "radius": {
                  "mode": "px",
                  "value": 8
                },
                "fontSize": {
                  "mode": "px",
                  "value": 14
                },
                "textColor": "#F9F9F9",
                "fontWeight": 400,
                "borderColor": "transparent",
                "borderStyle": "solid",
                "borderWidthPx": 1
              },
              "layout": {
                "align": "center",
                "justify": "center",
                "height": {
                  "mode": "px",
                  "value": 38
                },
                "padding": [
                  {
                    "mode": "px",
                    "value": 8
                  },
                  {
                    "mode": "px",
                    "value": 16
                  }
                ]
              },
              "children": [],
              "triggers": [
                {
                  "on": "click",
                  "action": "emit",
                  "target": "confirm",
                  "payload": "{{props.item}}"
                }
              ],
              "cssClasses": ["confirm-btn", "confirm-btn-danger"],
              "layoutMode": "auto"
            }
          ],
          "cssClasses": ["confirm-actions"],
          "layoutMode": "flow"
        }
      ],
      "cssClasses": ["confirm-dialog"],
      "layoutMode": "flow"
    }
  }
}
